/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component, createRef } from 'react';
import { Form, Button, Col, Row, Modal, Spinner, OverlayTrigger, Tooltip } from 'react-bootstrap';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import moment from 'moment';
import * as momentTz from 'moment-timezone';

// project imports
import Datatable from 'shared/datatable';
import { ArrayValueReorder, commonMobileNumberFormat } from 'shared/modifiers';
import { getSellerUrl, getSellerHeaders ,getBuyerUrl,getBuyerHeaders, getAdminUrl, getAdminHeaders, getMembermbershipUrl} from 'shared/http';
import {
    buyerdetail, locationlist, invoiceList, buyersuspend, buyersuspendlist, buyerunsuspend,membershipUpdate,creditsAdd,resendOtp,mobileOtp,buyerVerify,otpVerify,reactivate,bannedwords,
    buyerchangeemail, buyerresendverifyemail,defaultPassword,deleteuser, taxexemptstatus, buyerdetailview, secret_key, updateBuyerUserName,buyerShippingAddress, buyersuspendalllist, paymentMethodCount, buyerunsuspendalllist, deleteUserValid,buyersuspendcount, memberslist, buyerloglist,
    getCaDetails,additionalAddressList,
    checkEmail,
    logoutUser,
} from 'shared/settings/apiconfig';
import Validators from 'shared/validators';
import { ToasterMessage } from 'shared/toast/toast';
import InvoiceView from './InvoiceView';
import { mobileNumberFormat } from 'shared/modifiers';
import { Link } from 'react-router-dom';


// style imports
import './BuyerEdit.scss';
import { error } from 'highcharts';
import { DISABLED_REASON, SUSPENSION_REASON, UNSUSPENSION_REASON } from 'shared/settings/config';
import { capitalizeFirstLetter } from 'shared/utils';
import MembershipInvoice from './MembershipInvoice';
import { NoData } from 'features/components/redirect/NoData';
import { navigateToHelpCenter } from 'shared/utils/utils';

/**
 * this page is used to list buyers
 * 
 * @param props
 * 
 * @returns html code to render the buyers list
 * 
**/

export class BuyerEdit extends Component {

    buyerId;
    tooltipRef;
    locationOptions;
    config;
    dataTable;
    search;

    constructor(props) {
        super(props);
        this.timeoutInterval = {};
        this.dataTable = createRef();
        this.prevPath = this.props.location.state?.prevPath ? { pathname: this.props.location.state.prevPath, state: { saletitle: this.props.location.state.saletitle } } : '/buyer';
        this.buyerId = this.props.location.pathname.slice(this.props.location.pathname.lastIndexOf('/') + 1);
        this.state = {
            membershipDisable: false,
            membershipInvoiceModal: false,
            caDetails: '',
            updateNameLoader: false,
            addressNameCheckError: '',
            form: {
                id: '',
                active: '',
                isDeleted: '',
                isReactive: '',
                reactivationDate: '',
                profilecompleted: '',
                firstname: '',
                lastname: '',
                email: '',
                isEmailVerfied: false,
                mobile: '',
                isMobileVerfied: false,
                address1: '',
                address2: '',
                zipcode: '',
                state: '',
                city: '',
                country: '',
                taxexemptdate: '',
                total: '',
                pending: '',
                suspendedLocations: [],
                filteredsuspendedLocations: [],
                suspensionstatus: false,
                membershipDetails : {
                    id: '',
                    autoRenewal: '',
                    membershipStartDate: '',
                    membershipEndDate: '',
                    membershipStatus: '',
                    membershipInvoiceNumber : '',
                    disabledReasonType: { value : '', error: '', valid: false, validators: [Validators.required()] },
                    disabledReason: { value: '', error: '', valid: false, validators: [Validators.required(), Validators.maxLength(128)] },
                    reasonModal: false,
                    membershipDisableReason: '',
                    membershipModifiedDate: '',
                    membershipDesiabledNotes: '',
                    membershipUpdatedBy: '',
                    membershipcreditsused: '',
                    membershipCreditsAvailable: '',
                    membershipCreditsPending: '',
                    membershiptotalcredits: '',
                    membershipValid: true,
                    showGoogle: false,
                    showApple:false,
                    showFacebookd: false

                },
                credits:{
                    creditsadd : { value: '', error: '', valid: false, validators: [Validators.required()] },
                    creditsReason: { value: '', error: '', valid: false, validators: [Validators.required(), Validators.maxLength(128)] },
                    manageCreaditsModel:  false,
                    creditError: { show: false, type: '', message: '' },

                },
                membershipCompleted: '',
                suspend: {
                    locationid: { value: [], error: '', valid: false },
                    reason: { value: '', error: '', valid: false, validators: [Validators.required(), Validators.maxLength(400)] },
                    selectedAll: false,
                    selectedLocation: '',
                    // description: { value: '', error: '', valid: false, validators: [Validators.required] },
                    valid: false,
                    reasonModal: false,
                    // ispublic: { value: false },
                    suspensiontype: { value: '', error: '', valid: false, validators: [Validators.required()] },
                    alllocation: false
                },
                unsuspend: {
                    locationid: { value: [], error: '', valid: false },
                    selectedAll: false,
                    selectedLocation: '',
                    valid: false
                },
                unverifiedemail: null,
                isemailchanged: true,
                modifieddate: '',
                deleteProgressStatus: '',
                activeCount: '',
                inActiveCount: '',
                modifieddatename: '',
                modifieddatenickname: '',
                deleterequest: 0,
                unsuspendReason: {
                    locationid: { value: [], error: '', valid: false },
                    revokereason: { value: '', error: '', valid: false, validators: [Validators.required(), Validators.maxLength(400)] },
                    selectedAll: false,
                    selectedLocation: '',
                    valid: false,
                    unsuspendReasonModal: false,
                    revoketype: { value: '', error: '', valid: false, validators: [Validators.required()] },
                    alllocation: false,
                },
            },
            buyeradditionalAddressList: [],
            shippingAddr: {
                address1: '',
                address2: '',
                zipcode: '',
                state: '',
                city: '',
                country: '',
                modifieddate:''
            },
            primaryAddr: {
                address1: '',
                address2: '',
                zipcode: '',
                state: '',
                city: '',
                country: '',
                modifieddate:''
            },
            errorMessage: '',
            deleteUserLoading: false,
              paymentAddr: {
                address1: '',
                address2: '',
                zipcode: '',
                state: '',
                city: '',
                country: '',
                modifieddate:''
            },
            taxexemptColor: '',
            buttonText:'',
            errorpageredirect: false,
            locations: [],
            unsuspendedLocationList: [],
            loading: true,
            suspendLoading: false,
            deleteLoading: false,
            suspendModal: false,
            unsuspendModal: false,
            invoiceModal: false,
            invoiceId: '',
            searchLocationId: '',
            searchData: true,
            disableSuspend: false,
            isSuspended: false,
            suspendStatus: { show: false, type: '', message: '' },
            resetStatus: { show: false, type: '', message: '' },
            deleteStatus: { show: false, type: '', message: '' },
            filterSearch: {
                buyerid: { value: Number(this.buyerId), field: 'buyerid', op: '=', join: 'AND' },
            },
            emailResendLoading: false,
            emailVerifyLoading: false,
            emailModal: false,
            emailStatus: { show: false, type: '', message: '' },

            // change email
            newEmail: { value: '', error: '', validators: [Validators.required(), Validators.email()] },
            resetModal:false,
            deleteModal:false,
            signOutModal: false,
            maintain :props.location.state ,
            conformButton: false,
            UnsuspendDisable : false,
            SearchsuspendedLocationList: [],
            buyerToken: '',
            profileAddressModal: false,
            profileUpdateStatus: { show: false, type: '', message: '' },
            profileUpdateForm: {
                profile_firstname: { value: '', error: '', validators: [Validators.required(), Validators.validateNameLength(1, 45, "First Name")], valid: true },
                profile_lastname: { value: '', error: '', validators: [Validators.required(), Validators.validateNameLength(1, 45, "Last Name")], valid: true },
            },
            profileUpdateFormValid: false,
            profile_firstname: false,
            profile_lastname: false,
            deleteMessage: false,
            showSuspendedModal: false,
            suspendList: [],
            isSaveDisable: true,
            modifieddatenamechange: false,
            unsuspendList: [],
            unsuspensionModal: false,
            suspendDisable: false,
            suspendDataLoading: false,
            suspensionlocationlist: [],
            unsuspensionlocationlist: [],
            invoiceType: '',
            showReactivateUserModel: false,
            reactive: {
                mobile: {  value: '', error: '', validators: [Validators.required(), Validators.mobile()] },
                phoneNumberOtp: {value: ''},
                email: { value: '', error: '', validators: [Validators.required(), Validators.email()] },
                formvalid: false
            },
          
            phoneNumberOtpBtn: true,
            mailOtpbtn: true,
            allowPhoneNumber: true,
            verifyPhonenumber: true,
            allowEmail: false,
            showTooltip: false,
            otpAllow: false,
            messagetype: true,
            emailVerify: true,
            errorType: '',
            reactivateLog: [],
            reactivateLogModel: false,
            reactivateMsg: '',
            disablePhonenumberBtn: false,
            errorType: '',
            profileBtnDisable: false,
            apiLoading: false,
        }
        this.config = {
            url: invoiceList,
            params: { },
            columns: [
                { name: 'Location', property: 'locationtitle', sort: true, width: '130px' },
                { name: 'Sale', property: 'saletitle', sort: true, width: '250px' },
                { name: 'Invoice Generated Date', property: 'createddate', sort: true, width: '200px', columnType: 'custom', customColumn: this.customDate },
                { name: 'Invoice Amount', property: 'invoiceamount', sort: true, width: '150px', columnType: 'custom', customColumn: this.customAmount },
                { name: 'Sale Type', property: 'type', sort: true, width: '120px' },
                { name: 'Status', property: 'invoicestatus', sort: true, width: '120px' },
                { name: 'Invoice ID', property: 'invoicenumber', sort: true, width: '150px', columnType: 'custom', customColumn: this.customInvoice },
            ],
            sort: [{ field: 'id', direction: 'desc' }],
            pagination: true,
            field: ["locationtitle", "saletitle","createddate", "saleid", "invoiceamount", "type", "invoicestatus", "id", "buyerid", "invoicenumber",'view'],
            ignoreRowBackground: true
        };

        this.tooltipRef = createRef();
        this.locationOptions = [];
        this.approveBack = false;
        this.personalInfoData = {
            firstname: '',
            lastname: ''
        };
    }

    componentDidMount() {
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
        this.getBuyerToken();
        this.reactiveLog(false)
        localStorage.setItem('prevbuyerId', this.buyerId)
        this.getAddressDetail();
        this.getCadata();
        this.getAdditonalAddressDetail();
    }
    onBack = (e) => {
        e.preventDefault();
        if (this.approveBack) {
            window.removeEventListener('popstate', this.onBack);
        } else {
            this.approveBack = true;
            this.navigateToList();
        }
    }
    getAddressDetail = () => {
        let addressData = {
            filter: [
            {
                "field": "buyerid",
                "value": this.buyerId,
                "op": "=",
                "join": "AND"
            },
            {
                "field": "shipping",
                "value": 1,
                "op": "=",
                "join": "OR"
            },
            {
                "field": "addresstype",
                "value": "Primary",
                "op": "=",
                "join": "AND"
            }
        ]
        }
        axios.post(getSellerUrl(`${buyerShippingAddress}`), JSON.stringify(addressData), getSellerHeaders())
        .then(response => {
            if (response.status === 200) {
                this.setState({
                    primaryAddr: response?.data?.data[0],
                    shippingAddr: response?.data?.data[1] ? response?.data?.data[1] : response?.data?.data[0] ,
                })
            }
        })
    }

    getCadata = () => {
        let data = {
            "filter": [
                {
                    "field": "buyerid",
                    "value": parseInt(this.buyerId),
                    "op": "=",
                    "join": "AND"
                }
            ],
            "sort": [
                {
                    "field": "createdDate",
                    "direction": "desc"
                }
            ],
            "page": {
                "size": 1
            }
        }
        
        axios.post(getAdminUrl(getCaDetails), JSON.stringify(data), getAdminHeaders())
            .then(response => {
               this.setState({
                caDetails :  response?.data?.data?.length > 0 ? response?.data?.data[0] : null
               })
            })
    }
      resetPasswordfn = () => {
        this.setState({ resetModal: true })
        let data = {
            "data": {
                "buyerId": parseInt(this.buyerId)
            }
        }
        axios.post(getAdminUrl(checkEmail), JSON.stringify(data), getAdminHeaders())
            .then(response => {
               this.setState({
                emailValid :  response?.data?.data?.length > 0 ? true : false
               })
            })
    }
    disabledMembership = () => {

        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                membershipDetails: {
                    ...this.state.form.membershipDetails,
                    reasonModal: true
                },
            }
        })
    }
    openManageCredits = () => {
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                credits: {
                    ...this.state.form.credits,
                    manageCreaditsModel: true
                },
            }

        })

    }
    closeCreditsModel = () =>{
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                credits: {
                    ...this.state.form.credits,
                    manageCreaditsModel: false,
                    creditsReason:  {
                        ...this.state.form.credits.creditsReason,
                       value: ''
                    },
                    creditsadd:  {
                        ...this.state.form.credits.creditsadd,
                       value: ''
                    },
                    creditError: {
                        ...this.state.form.credits.creditError,
                        show: false,
                        error: ''
                    },
                },
            }
        })

    }

    creditsAdd = (event) =>{
        let value = event.target.value;
        if (event.target.name === "creditsadd") {
            value = value.replace(/[^0-9-]/g, '');
        
            if (value.includes('-')) {
                value = value.replace(/-/g, '');
                value = `-${value}`;
            }
        }
    
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                credits: {
                    ...this.state.form.credits,
                    [event.target.name]: {
                        value: value
                    }
                }
            }
        });


    }
    updatedByNameFn = (data) => {
        if(data == "ctbids_buyer"){
            return 'Bidder'
        }
        else{
            let value = data.split('_')
            return value[1].charAt(0).toUpperCase() + value[1].slice(1);
        }
    }

    getMembershipDetail = () => {
        let data = {
            field: ["buyeremail", "planname","creditsused","creditspurchased","creditspending","totalcredits", "startdate", "status", "enddate", "autorenewal", "buyeremail", "membershipplanid", "buyerid","modifieddate", "updatedby", "id","disabledreason","disablednotes", "invoicenumber"],
            filter: [
                { field: "buyeremail", value: this.state.form.email, op: "LIKE", join: "AND" },
            ]
        }
        axios.post(getAdminUrl(memberslist), JSON.stringify(data), getAdminHeaders()).then((res) => {
            let value = res.data.data[0]
            this.setState({
                ...this.state,
                form: {
                    ...this.state.form,
                    membershipDetails: {
                        id: value.id,
                        autoRenewal: value.autorenewal,
                        membershipStartDate: value.startdate,
                        membershipEndDate: value.enddate,
                        membershipStatus: value.status,
                        membershipInvoiceNumber: value.invoicenumber,
                        membershipModifiedDate: value.modifieddate,
                        membershipUpdatedBy: value.updatedby,
                        membershipDisableReason: value.disabledreason,
                        membershipDesiabledNotes: value.disablednotes,
                        membershipcreditsused: value.creditsused,
                        membershipCreditsAvailable: value.creditsremaining,
                        membershipCreditsPending: value.creditspending,
                        membershiptotalcredits: value.creditspurchased,
                        membershipValid: false
                    },
                }
            })

        }).catch((error) => {

        })
    }

    setCreditsValue = () => {
        this.setState({
            manageCreditsButton: true
        })
        let data = {
            "data": {
                "buyerid": this.buyerId,
                "membershipid": this.state.form.membershipDetails.id,
                "credit": parseInt(this.state.form.credits.creditsadd.value),
                "notes":  this.state.form.credits.creditsReason.value,
            }
        }
        axios.post(getAdminUrl(creditsAdd), JSON.stringify(data), getAdminHeaders()).then((res) => { 
            this.getMembershipDetail();
                    this.setState({
                manageCreditsButton: false,
                form: {
                    ...this.state.form,
                    credits: {
                        ...this.state.form.credits,
                        manageCreaditsModel: false,
                        creditsReason:  {
                            ...this.state.form.credits.creditsReason,
                           value: ''
                        },
                        creditsadd:  {
                            ...this.state.form.credits.creditsadd,
                           value: ''
                        },
                        creditError: {
                            ...this.state.form.credits.creditError,
                            show: false,
                            error: ''
                        },
                    },
                }
            });
        }).catch((error) => {
            this.setState({
                ...this.state,
                manageCreditsButton: false,
                form: {
                    ...this.state.form,
                    credits: {
                        ...this.state.form.credits,
                        creditError: {
                            ...this.state.form.credits.creditError,
                        show: true,
                        type: 'danger',
                        error: error.response.data['message']
                    }
                    },
                }
            })
        })

    }

    customInvoice = (values) => {
        return (
            <div className="d-flex">
                <div className="" style={{ paddingTop: "3%" }}>{values['invoicenumber']}</div>
                <div className="">
                    <img src={`${process.env.PUBLIC_URL}/static/icons/sidebar/Seller_invoice.svg`} className="text-dark"
                        onClick={() => { this.setState({ invoiceModal: true, invoiceId: values['id'], invoiceType: values['type'] }) }}
                        alt="invoice" height="30px" width="30px" />
                </div>
            </div>
        );
    }

    customAmount = (values) => {
        return (
            <span>${values['invoiceamount'].toFixed(2)}</span>
        );
    }
    customDate = (value) => {
        if (value['createddate']) {
            return `${ moment.utc(value['createddate']).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        return '- - -';
    };

    getBuyerToken() {
        axios.get(getSellerUrl(`${secret_key}`), getSellerHeaders()).then(response => {
            if (response.data.status.toLowerCase() === 'success') {
                this.setState({
                    buyerToken: response.data.accessToken,
                }, () => { 
                    this.getBuyerDetail();
                });
            }
        }).catch(error => {
            if(error.response.status == 401 || error.response.status == 404) {
                this.setState({
                    errorpageredirect: true,
                    errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                })
            }
        });
    }

    /* get buyer detail */
    getBuyerDetail = async () => {
        try {
            // Set loading true initially
            this.setState({ loading: true });

            //Get Buyer Details
            const buyerPostData = {
                field: [
                        'id', 'firstname', 'lastname', 'email', 'mobile', 'emailverified', 'mobileverified','profilecompleted','isDeleted','isreactivate',
                        'reactivaterequestdate',"googleid","appleid","facebookid","suspensionstatus",'total', 'active', 'address1', 'address2', 'zipcode', 'state',
                        'city', 'country','taxexemptdate', 'modifieddate', 'deletestatus',"modifieddatename","modifieddatenickname","deleteRequest","membershipCompleted"
                    ]
            };

            const buyerResponse = await axios.post(getSellerUrl(`${buyerdetail}/${this.buyerId}`),JSON.stringify(buyerPostData),getSellerHeaders());

            const buyerData = buyerResponse.data.data[0];

                localStorage.setItem('prevfirstname', buyerData.firstname)
                localStorage.setItem('prevlastname', buyerData.lastname)
                localStorage.setItem('prevbuyerId', this.buyerId)
                this.personalInfoData = {
                    firstname: buyerData.firstname,
                    lastname: buyerData.lastname
                }
                this.setState({
                    form: {
                        ...this.state.form,
                        firstname: buyerData.firstname,
                        lastname: buyerData.lastname,
                        isDeleted:  buyerData.isDeleted,
                        isReactive:  buyerData.isreactivate,
                        reactivationDate: buyerData.reactivaterequestdate,
                        email: buyerData.email,
                        isEmailVerfied: buyerData.emailverified,
                        mobile: buyerData.mobile,
                        isMobileVerfied: buyerData.mobileverified,
                        total: buyerData.total,
                        id: buyerData.id,
                        active: buyerData.active,
                        profilecompleted:  buyerData.profilecompleted,
                        address1: buyerData.address1,
                        address2: buyerData.address2,
                        zipcode: buyerData.zipcode,
                        state: buyerData.state,
                        city: buyerData.city,
                        country: buyerData.country,
                        taxexemptdate: buyerData.taxexemptdate,
                        modifieddate: buyerData.modifieddate,
                        deleteProgressStatus: typeof buyerData.deletestatus == 'string' ? JSON.parse(buyerData.deletestatus) : {},
                        modifieddatename: buyerData.modifieddatename,
                        modifieddatenickname: buyerData.modifieddatenickname,
                        deleterequest: buyerData.deleteRequest,
                        membershipCompleted: buyerData.membershipCompleted,
                        showGoogle: buyerData.googleid,
                        showApple: buyerData.appleid,
                        showFacebookd: buyerData.facebookid,
                        suspensionstatus: buyerData.suspensionstatus
                    },
                    profileUpdateForm: {
                        ...this.state.profileUpdateForm,
                        profile_firstname: { ...this.state.profileUpdateForm.profile_firstname, value: buyerData.firstname },
                        profile_lastname: { ...this.state.profileUpdateForm.profile_lastname, value: buyerData.lastname },
                    },
                    reactive: {
                        ...this.state.reactive,
                        email: {
                            ...this.state.reactive.email,
                           value: buyerData.email
                        },
                        mobile: {
                            ...this.state.reactive.mobile,
                            value: buyerData.mobile,
                        }
                    },
                },()=>{
                    this.getMembershipDetail()
                    this.suspentioncount();
                });

            //Get Location List
            const locationResponse = await axios.post(
                getSellerUrl(locationlist),
                JSON.stringify({ field: ['id', 'title'] }),
                getSellerHeaders()
            );

            let defaultLocationId = null;
            if (locationResponse.data.data.length > 0) {
                const locations = ArrayValueReorder(locationResponse.data.data, 'title');
                this.locationOptions = locations.map(location => ({ title: location['title'], id: location['id'] }));
                defaultLocationId = '';

                this.setState({
                    locations,
                    searchLocationId: defaultLocationId
                }, () => {
                    if (this.state.searchLocationId) this.exemptStatus(this.state.searchLocationId);
                    this.buyerDetailView(this.state.searchLocationId);
                });
            }

            //Get Suspended Locations
            const suspendPostData = {
                filter: [{ field: 'buyerid', value: Number(this.buyerId), op: '=', join: 'AND' }]
            };

            const suspendResponse = await axios.post(getSellerUrl(buyersuspendlist), JSON.stringify(suspendPostData), getSellerHeaders());
                if (suspendResponse.data.data.length > 0) {
                    this.setState({
                        suspendedLocationList : suspendResponse.data.data,
                        form: {
                            ...this.state.form,
                            suspendedLocations: suspendResponse.data.data,
                            filteredsuspendedLocations: suspendResponse.data.data
                        }
                    });

                // Remove suspended locations from locationOptions
                suspendResponse.data.data.forEach(element => {
                    const index = this.locationOptions.findIndex(el => el.id === element.locationid);
                    if (index > -1) this.locationOptions.splice(index, 1);
                });
            }

            //Get Payment Method Count
            const paymentResponse = await axios.get(getSellerUrl(`${paymentMethodCount}${this.buyerId}`), getSellerHeaders());

                const paymentMethodData = paymentResponse.data.data;
                this.setState({
                    form: {
                        ...this.state.form,
                        activeCount: paymentMethodData.activeCount,
                        inActiveCount: paymentMethodData.inActiveCount
                    }
                })

            //Final state updates
            this.setState({
                loading: false,
                unsuspendedLocationList: this.locationOptions,
                isSuspended:
                    (defaultLocationId === '' && suspendResponse.data.data.length > 0) ||
                        suspendResponse.data.data.findIndex(el => el.locationid === defaultLocationId) > -1 ? true
                        : false
            });

        } catch (error) {
                this.setState({
                    loading: false,
                });
                if(error.response?.status == 401 || error.response?.status == 404) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                });
            }
        }
    };

    buyerDetailView = (locationid) => {
        let filterArray = [];
        if(locationid) {
            filterArray.push({ field: 'locationid', value: locationid, op: '=', join: 'AND' })
        }
        const buyerViewPostData = {
            field: [
                "invoicepaidcount",
                "invoiceunpaidcount",
                "itemswoncount",
                "suspendedcount",
                "unsuspendedcount",
                "itemsbidcount"
            ],
            filter: filterArray
        }
        axios.post(getSellerUrl(`${buyerdetailview}/${this.buyerId}`), JSON.stringify(buyerViewPostData), getSellerHeaders()).then(response => {
            this.setState({
                form: {
                    ...this.state.form,
                    bidWonCount: response.data.data[0].bidWonCount,
                    // buyerSuspendCount: response.data.data[0].buyerSuspendCount,
                    invoicepaidcount: response.data.data[0].invoicepaidcount,
                    invoiceunpaidcount: response.data.data[0].invoiceunpaidcount,
                    itemBidCount: response.data.data[0].itemBidCount,
                    nickname: response.data.data[0].nickname,
                    signupdate: response.data.data[0].signupdate,
                    // unsuspendedcount: response.data.data[0].unsuspendedcount
                }
            })
        }).catch(error => {
            if(error.response.status == 401 || error.response.status == 404) {
                this.setState({
                    loading: false,
                    errorpageredirect: true,
                    errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                })
            }
        })

    }
    suspentioncount = () => {
        axios.get(getBuyerUrl(`${buyersuspendcount}${this.buyerId}`), getBuyerHeaders(this.state.buyerToken)).then(
            response => {
                if (response.data.status === 'success') {
                    this.setState({
                        suspensionlocationlist: response.data.data.suspended_data,
                        unsuspensionlocationlist: response.data.data.unsuspended_data,
                        form: {
                            ...this.state.form,
                            buyerSuspendCount: response.data.data.suspended_count,
                            unsuspendedcount: response.data.data.unsuspended_count
                        }
                    })
                 
                }
            }).catch(
                error => {
                   
                }
            );
      

    }

    exemptStatus = (locId) => {
        let filterArray = [
            { field: 'buyerid', value: Number(this.buyerId), op: '=', join: 'AND' }
        ]
        if(locId) {
            filterArray.push({ "field": "locationid", "value": [[locId]], op: 'IN', join: 'AND' })
        }
        const taxExemptStatusData = { 
            filter: filterArray
        };
        axios.post(getBuyerUrl(taxexemptstatus), JSON.stringify(taxExemptStatusData), getBuyerHeaders(this.state.buyerToken)).then((result) => {
            
            let txt = null;
            let color = null;
            if (result?.data?.data?.exemptedstatus === 'NOTAXEXEMPTION') {
                txt = 'No Tax Exemption';
                color = 'white';
            }
            if (result?.data?.data?.exemptedstatus === 'PENDING') {
                color = 'red';
                txt = 'Tax Exemption Not Added';

            }
            if (result?.data?.data?.exemptedstatus === 'EXEMPTED') {
                color = 'green';
                txt = 'Tax Exemption Added';
            }
            if (result?.data?.data?.exemptedstatus === 'EXPIRED') {
                color = 'orange';
                txt = 'Tax Exemption Expired';
            }
            this.setState({
                taxexemptColor: color,
                buttonText: txt,
            })
        }).catch(error=>{

        })
    }

    /* Tooltip for suspended locations */
    suspendedToolTip = () => {
        return (
            <div>
                <div className="text-secondary"> Suspended Locations</div>
                {
                    this.state.form.suspendedLocations.length > 0 ?
                        this.state.form.suspendedLocations.map(
                            (suspendLocation, index) => (
                                <div className={index !== this.state.form.suspendedLocations.length - 1 ? 'border-bottom' : ''}>
                                    {index + 1}. {this.state.locations.find(el => el['id'] === suspendLocation['locationid'])['title']}
                                </div>
                            )
                        ) :
                        <span>- - - - -</span>
                }
            </div>
        );
    }

    /* Enable suspend modal */
    setSuspendModal = (value) => {
        this.setState({ 
            form: {
                ...this.state.form,
                suspend: {
                    ...this.state.form.suspend,
                    reasonModal: value,
                }
            }
        });
    }
    disabledReason = (event) => {
        let value = event.target.value
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                membershipDetails: {
                    ...this.state.form.membershipDetails,
                    [event.target.name]: {
                        value: value
                    }
                }
            }
        });

    }

    /* Called when input changes */
    suspendInputChange = (event, control, name, id = null) => {
        let eventValue = '';
        let inputError = '';

        if (name === 'locationid') {
            eventValue = this.state.form[control].locationid.value;
            if (id === 'all') {
                let ids = [];
                if (!this.state.form[control].selectedAll) {
                    if (control === 'suspend') {
                        this.state.unsuspendedLocationList.forEach(location => {
                            ids.push(location['id']);
                        });
                    }
                    else {
                        this.state.form.filteredsuspendedLocations.forEach(location => {
                            ids.push(location['locationid']);
                        });
                    }
                    eventValue = ids;
                }
                else
                    eventValue = []
            }
            else {
                if (this.state.form[control].locationid.value.includes(id)) {
                    eventValue.splice(eventValue.indexOf(id), 1);
                }
                else
                    eventValue.push(id);
            }
            if (!eventValue.length)
                inputError = 'Please enter value';
        }
        else {
            if(name === 'ispublic') {
                eventValue = event.target.checked ? true : false
            } else {
                eventValue = event.target.value;
            }
        }
        /*validation */
        if (Object.keys(this.state.form[control][name]).includes('validators')) {
            for (let validator of this.state.form[control][name].validators) {
                inputError = validator(eventValue);
                if (inputError) break;
            }
        }
        this.setState({
            form: {
                ...this.state.form,
                [control]: {
                    ...this.state.form[control],
                    [name]: {
                        ...this.state.form[control][name],
                        value: eventValue,
                        error: inputError,
                        valid: !Boolean(inputError)
                    }
                }
            }
        }, () => {
            let valid = false;
            let selectedAllLocation = this.state.form[control].selectedAll;
            if (this.state.form[control].locationid.value.length)
                valid = true;
            if (name === 'locationid' && id === 'all')
                selectedAllLocation = !this.state.form[control].selectedAll;
            if (name === 'locationid' && id !== 'all') {
                selectedAllLocation = this.state.form[control].locationid.value.length ? selectedAllLocation : false;
                this.checkBoxChecked(eventValue, control);
            }
            this.setState({
                form: {
                    ...this.state.form,
                    [control]: {
                        ...this.state.form[control],
                        valid: valid,
                        selectedAll: selectedAllLocation,
                        alllocation: selectedAllLocation
                    }
                }
            });
        });
    }

    updateSuspend = async () => {
        const suspendPostData = {
            filter: [
                { field: 'buyerid', value: Number(this.buyerId), op: '=', join: 'AND' }
            ]
        };
        await axios.post(getSellerUrl(buyersuspendlist), JSON.stringify(suspendPostData), getSellerHeaders())
            .then(response => {
                this.setState({
                    form: {
                        ...this.state.form,
                        suspendedLocations: response.data.data,
                        filteredsuspendedLocations: response.data.data
                    }
                });

                response.data.data.forEach(element => {
                    let index = this.locationOptions.findIndex(el => el['id'] === element['locationid']);
                    if (index > -1) {
                        this.locationOptions.splice(index, 1);
                    }
                });
                this.setState({ 
                    unsuspendedLocationList: this.locationOptions,
                    isSuspended: (this.state.searchLocationId == '' && response.data.data.length > 0) || response.data.data.findIndex(el => el['locationid'] === this.state.searchLocationId) > -1 ? true : false,
                    
                    // form: {
                    //     ...this.state.form,
                    //     buyerSuspendCount: response.data.data.length,
                    // }
                });
                this.buyerDetailView(this.state.searchLocationId);
            })
            .catch(error => {
                // toast.error(error.response.data.message);
            });
    };

    /* Submit suspend data */
    submitSuspend = async () => {
        this.setState({ suspendLoading: true, suspendDataLoading: true });
        let data = [];

        this.state.form.suspend.locationid.value.forEach(value => {
            if (value['suspendid'] === undefined) {
                data.push({
                    buyerid: Number(this.buyerId),
                    locationid: value,
                    reason: this.state.form.suspend.reason.value,
                    suspensiontype: this.state.form.suspend.suspensiontype.value,
                });
            }
        });
        await axios.post(getSellerUrl(buyersuspend), JSON.stringify({ data: {locations: data, alllocations: this.state.form.suspend.alllocation}}), getSellerHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    this.setState({
                        suspendDataLoading: false,
                        suspendStatus: { show: true, type: 'success', message: 'Saved' },
                        conformButton: true
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                form: {
                                    ...this.state.form,
                                    suspend: {
                                        ...this.state.form.suspend,
                                        valid: false,
                                        selectedLocation: '',
                                        reasonModal: false,
                                        selectedAll: false,

                                        locationid: {
                                            ...this.state.form.suspend.locationid,
                                            value: []
                                        },
                                        reason: {
                                            ...this.state.form.suspend.reason,
                                            value: '',
                                            error: '',
                                            valid: false
                                        },
                                        suspensiontype: { value: '' },
                                    }
                                },
                                suspendLoading: false,
                                suspendStatus: { show: false, type: '', message: '' },
                                suspendModal: false,
                                conformButton: false
                            });
                            this.updateSuspend();
                            this.suspentioncount()
                        }, 3000);
                    });
                }
            })
            .catch(error => {
                this.setState({
                    suspendLoading: false,
                    suspendStatus: { show: true, type: 'danger', message: error.response.data.message }
                });

            });
    }

    /* set search to filter table data */
    enableSearch = (event) => {
        let isLocationSuspended = false;
        this.state.form.suspendedLocations.forEach(element => {
            if (Number(element['locationid']) === Number(event.target.value))
                isLocationSuspended = true;
        })
        this.setState({
            searchLocationId: event.target.value,
            isSuspended: isLocationSuspended
        }, () => {
            let search = { };
            search = {
                locationid: { value: this.state.searchLocationId ? Number(this.state.searchLocationId) : '', field: 'locationid', op: '=', join: 'AND' },
                buyerid: { ...this.state.filterSearch.buyerid, join: 'AND' }
            }
            this.setState({
                filterSearch: search,
                searchData: true
            }, () => {
                if(this.state.searchLocationId) {
                    this.exemptStatus(Number(this.state.searchLocationId));
                }
                this.dataTable.current.searchData();
            });
            this.buyerDetailView(this.state.searchLocationId)
        });
    }

    /* update the data when changed */
    updateTableData = (event) => {
        this.setState({
            ...this.state,
            tableData: event
        });
    }

    /* Navigate to tax exemption page */
    navigateTaxExemption = () => {
        let state = { firstname: this.state.form.firstname, lastname: this.state.form.lastname, id: this.buyerId, state: this.state.maintain,locationId : parseInt(this.state.searchLocationId) };
        this.props.history.push({ pathname: `/buyer/edit/${this.buyerId}/taxexemption`, state });
    }

    /* resend suspend data when cancel */
    resetSuspend = () => {
        this.setState({
            suspendModal: false,
            unsuspendedLocationList: this.locationOptions,
            form: {
                ...this.state.form,
                suspend: {
                    locationid: { value: [], error: '', valid: false },
                    reason: { value: [], error: '', valid: false, validators: [Validators.required] },
                    selectedAll: false,
                    selectedLocation: '',
                    valid: false,
                    reasonModal: false,
                    suspensiontype: { value: '' },
                    alllocation: false
                }
            }
        })
    }

    /* show change buyer email modal */
    showEmailModal = () => {
        this.setState({ emailModal: true });
    };

    /* hide change buyer email modal */
    hideEmailModal = () => {
        this.setState({ emailModal: false }, () => {
            if (!this.state.form.unverifiedemail) {
                this.setState({
                    emailVerifyLoading: false,
                    newEmail: {
                        ...this.state.newEmail,
                        value: '',
                        error: ''
                    },
                    form: {
                        ...this.state.form,
                        isemailchanged: true
                    }
                });
            } else {
                this.setState({
                    newEmail: {
                        ...this.state.newEmail,
                        value: this.state.form.unverifiedemail,
                        error: ''
                    },
                    form: {
                        ...this.state.form,
                        isemailchanged: false
                    }
                });
            }
        });
    };

    /* on email input change */
    onEmailChange = (event) => {
        let inputError = '';

        /* check validation */
        for (let validator of this.state.newEmail.validators) {
            inputError = validator(event.target.value);
            if (inputError) break;
        }

     


        if (event.target.value === this.state.form.email)
            inputError = 'Should not use same email';

        this.setState({
            newEmail: {
                ...this.state.newEmail,
                value: event.target.value,
                error: inputError
            }
        },()=>{
            
            this.setState({ profileBtnDisable: true },()=>{
                if (this.timeoutInterval) {
                    clearTimeout(this.timeoutInterval);
                }
                this.timeoutInterval = setTimeout(() =>  {
                    this.formatData(event, inputError);
                }, 500);
            });
        });
    };

    saveNewEmail = async () => {
        if (this.state.form.unverifiedemail === this.state.newEmail.value && !this.state.form.isemailchanged) {
            this.setState({
                form: {
                    ...this.state.form,
                    isemailchanged: true
                }
            });
        }
        else {
            if (!this.state.newEmail.error && this.state.newEmail.value) {
                const data = {
                    data: {
                        newemail: this.state.newEmail.value,
                        buyerid: this.buyerId
                    }
                }

                this.setState({ emailVerifyLoading: true });
                await axios.put(getSellerUrl(buyerchangeemail), JSON.stringify(data), getSellerHeaders())
                    .then(response => {
                        this.setState({
                            form: {
                                ...this.state.form,
                                unverifiedemail: this.state.newEmail.value,
                                emailverified: 0
                            },
                            emailVerifyLoading: false,
                            emailStatus: { show: true, type: 'success', message: "An email has been sent to verify the new email address and create a new password" } 
                        }, () => {
                            setTimeout(() => {
                                this.setState({
                                    emailStatus: { show: false, type: '', message: '' },
                                    emailModal: false,
                                    scmlinked: true,
                                    form: {
                                        ...this.state.form,
                                        isemailchanged: false
                                    }
                                });
                                if(!this.state.scmlinked){
                                    this.getBuyerDetail()
                               }
                            }, 3000);
                        });
                    })
                    .catch(error => {
                        this.setState({
                            emailVerifyLoading: false,
                            emailStatus: { show: true, type: 'danger', message: error.response.data['message'] || 'Failed to update email' }
                        }, () => {
                            setTimeout(() => {
                                this.setState({
                                    emailStatus: { show: false, type: '', message: '' }
                                });
                            }, 3000);
                        }); 
                         
                    });
            }
        }
    };

    /* request to re-send verify email for new email */
    verifyNewEmail = async () => {
        this.setState({ emailResendLoading: true });
        const data = {
            buyerid: this.buyerId
        };
        await axios.post(getSellerUrl(buyerresendverifyemail), JSON.stringify({ data: data }), getSellerHeaders())
            .then(response => {
                this.setState({
                    emailStatus: { show: true, type: 'success', message: response.data['message'] }
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            emailStatus: { show: false, type: '', message: '' },
                            emailModal: false,
                            emailResendLoading: false
                        });
                    }, 3000);
                });
            })
            .catch(error => {
                this.setState({
                    emailStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            emailStatus: { show: false, type: '', message: '' },
                            emailResendLoading: false
                        });
                    }, 3000);
                });
            });
    };

    navigateToList = () => {
        this.props.history.push({ pathname: this.props.location.state?.prevPath ? this.prevPath.pathname : '/buyer', state: {...this.state.maintain, datatable : this.props?.location?.state?.tabledata} });
    };

    /* check selected location id*/
    checkBoxChecked = (id, control) => {
        if (this.state.form[control].locationid.value.includes(id))
            return true;
        else
            return false;
    }

    /* filter unsuspeded location to suspend */
    filterUnSuspendLocation = (value) => {
        let SearchsuspendedLocationList = this.state.unsuspendedLocationList
        let locationList = [];
        if (value) {
            locationList = this.locationOptions.filter(x => x.title.toLowerCase().includes(value.toLowerCase()));
        } else {
            locationList = this.locationOptions
        }
        this.setState({
            unsuspendedLocationList: locationList,
            form: {
                ...this.state.form,
                suspend: {
                    ...this.state.form.suspend,
                    selectedLocation: value,
                    // locationid: { value: [], error: '', valid: false },
                    // reason: { value: '', error: '', valid: false },
                    // selectedAll: false,
                    // valid: false
                }
            }
        });
    }

    /* Enable reason modal */
    setReasonModal = () => {
        this.setState({
            form: {
                ...this.state.form,
                suspend: {
                    ...this.state.form.suspend,
                    reasonModal: false,

                },
            },
            suspendModal: true
        });
    }
    resetDisableModel = () => {
        this.setState({
            form: {
                ...this.state.form,
                membershipDetails: {
                    ...this.state.form.membershipDetails,
                    disabledReasonType: { value : '', error: '' },
                    disabledReason: { value: ''},
                    reasonModal: false,
                },
            },
        });
    }
    setDisabledReason = () => {
        this.setState({
            membershipDisable: true
            
        })
        let reasonData = {
            "data": {
                "id": this.state.form.membershipDetails.id,
                "autorenewal": 0,
                "disabledreason": this.state.form.membershipDetails?.disabledReasonType?.value,
                "disablednotes":  this.state.form.membershipDetails?.disabledReason?.value
            }

        }
        axios.put(getAdminUrl(membershipUpdate), JSON.stringify(reasonData), getAdminHeaders()).then((res) => {
            this.getMembershipDetail()
            this.setState({
                membershipDisable: false,
                form: {
                    ...this.state.form,
                    membershipDetails: {
                        ...this.state.form.membershipDetails,
                        reasonModal: false,
                    },
                },
            });
        }).catch(()=>{
            this.setState({
                membershipDisable: false,
                form: {
                    ...this.state.form,
                    membershipDetails: {
                        ...this.state.form.membershipDetails,
                        reasonModal: false,
                    },
                },
            });

        })
 
      
    }

    /* Enable unsuspend modal */
    setUnSuspendModal = () => {
        this.setState({ unsuspendModal: true });
    }

    /* filter suspend location to unsuspend */
    filterSuspendLocation = (value) => {
        let locationList = [];
        if (value) {
            locationList = this.state.form.suspendedLocations.filter(x => x.locationtitle.toLowerCase().includes(value.toLowerCase()));
        }
        else {
            locationList = this.state.form.suspendedLocations
        }
        this.setState({
            form: {
                ...this.state.form,
                filteredsuspendedLocations: locationList,
                unsuspend: {
                    ...this.state.form.unsuspend,
                    selectedLocation: value,
                    // locationid: { value: [], error: '', valid: false },
                    // selectedAll: false,
                    // valid: false
                }
            }
        });
    }
    getAddressDetail = () => {
        let addressData = {
            filter: [
            {
                "field": "buyerid",
                "value": this.buyerId,
                "op": "=",
                "join": "AND"
            },
            {
                "field": "shipping",
                "value": 1,
                "op": "=",
                "join": "OR"
            },
            {
                "field": "addresstype",
                "value": "Primary",
                "op": "=",
                "join": "AND"
            }
        ]
        }
        axios.post(getSellerUrl(`${buyerShippingAddress}`), JSON.stringify(addressData), getSellerHeaders())
            .then(({ data, status }) => {
                if (status === 200) {
                    const addressTypes = {};

                    data?.data?.forEach(address => {
                        addressTypes[address.addresstype] = address;
                    });
                    let value = data.data

                    this.setState({
                        primaryAddr: addressTypes.Primary || {},
                        shippingAddr: addressTypes.Shipping ?  addressTypes.Shipping : addressTypes.Primary.shipping ? addressTypes.Primary : {},
                        paymentAddr: addressTypes.Payment || {}
                    });
                }
        }).catch(error => {
            this.setState({
                loading: false,
            });
            if(error.response?.status == 401 || error.response?.status == 404) {
                this.setState({
                    errorpageredirect: true,
                    errorType: error.response?.status == 401 ? 'expiryError' : error.response?.status == 404 ? 'noData' : ''
                })
            }
        })
    }

    getAdditonalAddressDetail = () => {
        let addressData = {
            filter: [
            {
                "field": "buyerid",
                "value": this.buyerId,
                "op": "=",
                "join": "AND"
            }
        ]
        }
        axios.post(getSellerUrl(`${additionalAddressList}`), JSON.stringify(addressData), getSellerHeaders())
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                       buyeradditionalAddressList:  response.data?.data,
                    });
                }
        }).catch(error => {
          
        })
    }
   

    /* Submit unsuspend data */
    submitUnSuspend = async () => {
        this.setState({ suspendLoading: true });
        const data = {
            data: {
                buyerid: Number(this.buyerId),
                locationid: this.state.form.unsuspend.locationid.value,
                revokereason: this.state.form.unsuspendReason.revokereason.value,
                revoketype: this.state.form.unsuspendReason.revoketype.value
            }
        }

        await axios.put(getSellerUrl(buyerunsuspend), JSON.stringify(data), getSellerHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    this.state.locations.forEach(location => {
                        this.state.form.unsuspend.locationid.value.forEach(id => {
                            if (id === location['id'])
                                this.locationOptions.push({ title: location['title'], id: location['id'] });
                        })
                    })
                    this.setState({
                        suspendLoading: false,
                        suspendStatus: { show: true, type: 'success', message: 'Saved' },
                        UnsuspendDisable: true
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                form: {
                                    ...this.state.form,
                                    unsuspend: {
                                        ...this.state.form.unsuspend,
                                        valid: false,
                                        selectedLocation: '',
                                        reasonModal: false,
                                        selectedAll: false,

                                        locationid: {
                                            ...this.state.form.unsuspend.locationid,
                                            value: []
                                        },
                                        suspend: {
                                            ...this.state.form.suspend,
                                            selectedAll: false
                                        }
                                    },
                                    suspend: {
                                        ...this.state.form.suspend,
                                        selectedAll: false
                                    },
                                    unsuspendReason: {
                                        locationid: { value: [], error: '', valid: false },
                                        revokereason: { value: '', error: '', valid: false, validators: [Validators.required()] },
                                        selectedAll: false,
                                        selectedLocation: '',
                                        valid: false,
                                        unsuspendReasonModal: false,
                                        revoketype: { value: '', error: '', valid: false, validators: [Validators.required()] },
                                        alllocation: false,
                                    },
                                },
                                suspendStatus: { show: false, type: '', message: '' },
                                suspendLoading: false,
                                unsuspendModal: false,
                                UnsuspendDisable: false,
                                unsuspendedLocationList: this.locationOptions,
                                unsuspendList: []
                            });
                            this.updateSuspend();
                            this.suspentioncount();
                        }, 3000);
                    });
                }
            })
            .catch(error => {
                this.setState({
                    suspendLoading: false,
                    suspendStatus: { show: true, type: 'danger', message: error.response.data.message }
                });

            });
    }

    /* reset unsuspend */
    // resetUnSuspend = () => {
    //     this.setState({
    //         unsuspendModal: false,
    //         form: {
    //             ...this.state.form,
    //             filteredsuspendedLocations: this.state.form.suspendedLocations,
    //             unsuspend: {
    //                 locationid: { value: [], error: '', valid: false },
    //                 selectedAll: false,
    //                 selectedLocation: '',
    //                 valid: false
    //             }
    //         }
    //     })
    // }
    resetPassword = async () => {
        const data = {
            data: {
                email: this.state.form.email
            }
        };
        await axios.post(getBuyerUrl(defaultPassword), JSON.stringify(data),getBuyerHeaders())
        .then(response => {
            if (response.status === 200) {
                this.setState({
                    ...this.state,
                    emailValid: false,
                    resetModal:false,
                    resetStatus: { show: true, type: 'success', message:"Password reset mail has sent" }
                },()=>{
                    setTimeout(() => {
                        this.setState({
                            resetStatus: { show: false, type: '', message: '' },
                        });
                    }, 3000);
                });
            }
        })
        .catch(error => {
            this.setState({
                ...this.state,
                resetModal:false,
                resetStatus: { show: true, type: 'danger', message: error.response.data.message }
            },()=>{
                setTimeout(() => {
                    this.setState({
                        resetStatus: { show: false, type: '', message: '' },
                    });
                }, 3000);
            }
            );
        });
    }

    deleteUser = async () => {
        this.setState({ deleteLoading: true });
        const data = {
            data: {
                id: this.state.form.id
            }
        };
        await axios.delete(getBuyerUrl(deleteuser + this.state.form.id), { ...getBuyerHeaders(), data: { 'data': data } })
            .then(response => {
                if (response.status === 200) {
                    this.getBuyerDetail()
                    this.setState({
                        ...this.state,
                        deleteLoading: false,
                        deleteStatus: { show: true, type: 'success', message: "User has been successfully deleted" },
                        // deleteStatus: { show: true, type: 'success', message: "User has been successfully deleted. If the request is through CCPA, the request would be marked Resolved" },
                        deleteMessage: true
                    });
                }
            })
            .catch(error => {
                this.setState({
                    ...this.state,
                    deleteLoading: false,
                    deleteStatus: { show: true, type: 'danger', message: error.response.data.message },
                    deleteMessage: false,
                    deleteModal: false
                });
            });
            setTimeout(() => {
                this.updateModifiedDate()
            }, 100);
    }

    redirectDeleteModal = () => {
        this.setState({ deleteModal: false })
        if (this.state.deleteStatus.type === 'success') {
            this.setState({
                form: {
                    ...this.state.form,
                    active: 0
                }
            });
            // this.props.history.push({ pathname: this.props.location.state?.prevPath ? this.prevPath.pathname : '/buyer', state: this.props.location.state?.prevPath ? this.prevPath.state : this.props.location.state });
        }
    }
    unsuspendedlocationfunction = () => {
        let sortingFunction = this.state.unsuspendedLocationList 

        sortingFunction.forEach(item => {
            item.title = item.title.trim();
        });

        sortingFunction.sort((a, b) => {
            return a.title.localeCompare(b.title);
        });
        return sortingFunction
    }
     getAddressTypeWithCount = (address, index, sortedAddresses) => {
        const count = sortedAddresses.slice(0, index + 1).filter( item => item?.addresstype?.toLowerCase() === address?.addresstype?.toLowerCase()).length;

        return `${address?.addresstype} ${count}`;
    };

    updateProfile = () => {

        this.setState({
            ...this.state,
            profileAddressModal: true,
            profileUpdateForm: {
                ...this.state.profileUpdateForm,
                profile_firstname: { ...this.state.profileUpdateForm.profile_firstname, error: this.validateName(this.state.profileUpdateForm.profile_firstname.value, 'First Name') },
                profile_lastname: { ...this.state.profileUpdateForm.profile_lastname, error: this.validateName(this.state.profileUpdateForm.profile_lastname.value, 'Last Name') },
            },
        }, () => {
            if (!this.state.profileUpdateForm.profile_firstname.error && !this.state.profileUpdateForm.profile_lastname.error) {
                const data = {
                    "data": {
                        "firstname": this.state.profileUpdateForm.profile_firstname.value,
                        "lastname": this.state.profileUpdateForm.profile_lastname.value
                    }
                };
                axios.post(getBuyerUrl(bannedwords), JSON.stringify(data),getBuyerHeaders())
                    .then(response => {

                        if (response.data.data.firstname.code == "CBBY016" || response.data.data.lastname.code == "CBBY016") {
                            this.setState({
                                ...this.state,
                                profileAddressModal: true,
                                profileUpdateForm: {
                                    ...this.state.profileUpdateForm,
                                    profile_firstname: { ...this.state.profileUpdateForm.profile_firstname, error: !response?.data?.data?.firstname?.valid ? response?.data?.data?.firstname?.message  : ''},
                                    profile_lastname: { ...this.state.profileUpdateForm.profile_lastname, error: !response?.data?.data?.lastname?.valid ?  response?.data?.data?.lastname?.message : '' },
                                }
                            },()=>{
                                console.log(this.state.profileUpdateForm.profile_lastname)
                            })
                        }

                    })
                    .catch(error => {

                    });

            }
        })
    }

    getSignupDatetime = (dateTime) => {
        const formatedDate = moment.utc(dateTime).local();
        let returnValue = formatedDate.format('MM/DD/YYYY hh:mm:ss A');
        let timeZone = moment.tz(moment.tz.guess()).zoneAbbr();

        return `${returnValue} ${timeZone}`;
    }
    timeformateChange = (dateTime) => {
        return `${ moment.utc(dateTime).format('MM/DD/YYYY hh:mm:ss A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
    }

    updateProfileAddress = () => {
        this.setState({updateNameLoader : true, addressNameCheckError: ''});
        const data = {
            data: {
                id: this.state.form.id,
                first_name: this.state.profileUpdateForm.profile_firstname.value,
                last_name: this.state.profileUpdateForm.profile_lastname.value,
                modifieddatename: this.state.modifieddatenamechange ? moment().utc().format('YYYY-MM-DD HH:mm:ss') : null
            }
        };
        axios.put(getAdminUrl(updateBuyerUserName), JSON.stringify(data), getAdminHeaders())
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                        ...this.state,
                        updateNameLoader: false,
                        form: {
                            ...this.state.form,
                            firstname: this.state.profileUpdateForm.profile_firstname.value,
                            lastname: this.state.profileUpdateForm.profile_lastname.value
                        },
                        profileUpdateStatus: { show: true, type: 'success', message: "User name has been updated successfully" }
                    },()=>{
                        setTimeout(() => {
                            this.setState({

                                profileAddressModal: false,
                                profileUpdateFormValid: false,
                                profileUpdateStatus: { show: false, type: '', message: '' },
                            });
                        }, 3000);
                        this.updateModifiedDate();
                    });
                }
            })
            .catch(error => {
                this.setState({
                    ...this.state,
                    updateNameLoader: false,
                    addressNameCheckError: error.response.data.message,
                    profileUpdateStatus: { show: true, type: 'danger', message: error.response.data.message }
                },()=>{
                  
                }
                );
            });
    }
    validateName = (value, name) => {
        const alphabeticPattern = /^[a-zA-Z\sáéíóúüñÁÉÍÓÚÜÑÊêÂâÎîÔôÛûËëÏïÜüòÒàÀèÈìÌùÙçÇ`']*$/;
        
         if (/\d/.test(value)) {
            return "This field only supports alphabetical characters."
        }
        else if (/[!@#$%^&*(),.?":{}|<>_\-+=~`[\]\\\/;'’]/.test(value)) {
            return "This field only supports alphabetical characters."
        }
        else if (/^\s+|\s+$/.test(value)) {
            return `Please delete any added spaces before or after your entry.`;
        } 
        else if(value.length === 1){
            return `${name} should be minimum of 2 characters`
        }
        else if (alphabeticPattern.test(value)) {
            return "";
        }
        else {
            return "Please enter a valid character";
        }
    };

    onInputValidation = (event, type) => {
        this.setState({
            [event.target.name] : true,
        })
      
        let controlError = '';

        /* checks all the validators for the control */
        for (let validator of this.state.profileUpdateForm[event.target.name].validators) {
            controlError = validator(event.target.value);
            if (controlError) break;
        }

        const validateName = (value) => {
            const alphabeticPattern = /^[a-zA-Z\sáéíóúüñÁÉÍÓÚÜÑÊêÂâÎîÔôÛûËëÏïÜüòÒàÀèÈìÌùÙçÇ`']*$/;
            if (alphabeticPattern.test(value)) {
                return "";
            }
            else if (/[!@#$%^&*(),.?":{}|<>_\-+=~`[\]\\\/;'’]/.test(value)) {
                return "This field only supports alphabetical characters."
            } else {
                return "Please enter a valid character";
            }
        };
    
        let inputValue = event.target.value;
        

        if (event.target.name === "profile_firstname" || event.target.name === "profile_lastname") {
            const alphabeticPatternError = validateName(inputValue)
            if (alphabeticPatternError) {
                controlError = alphabeticPatternError;
            }
        }


        if ((event.target.name === 'profile_firstname' || event.target.name === 'profile_lastname')) {
            const nameRegex = /^[a-zA-Z\xC0-\uFFFF`]+([-'.\s]?[a-zA-Z\xC0-\uFFFF`]+)*$/g;
            if (/^\s+|\s+$/.test(inputValue)) {
                controlError = `Please delete any added spaces before or after your entry.`;
            }
            else if(/\d/.test(inputValue)){
                controlError = `This field only supports alphabetical characters.`;
            }
        }

        /* sets the state of the control and form validity */
        this.setState({
            ...this.state,
            profileUpdateFormValid: false,
            profileUpdateStatus: { show: false, type: '', message: '' },
            profileUpdateForm: {
                ...this.state.profileUpdateForm,
                [type]: {
                    ...this.state.profileUpdateForm[type],
                    value: event.target.value,
                    error: controlError,
                    valid: !Boolean(controlError)
                }
            },
        }, () => {
               
            /* check form validity */
            if (controlError)
                this.setState({ profileUpdateFormValid: false });
            else {
                let profileUpdateFormValid = true;
                for (let control of Object.keys(this.state.profileUpdateForm)) {
                    if (!this.state.profileUpdateForm[control].valid) {
                        profileUpdateFormValid = false;
                        break;
                    }
                }
                this.setState({ profileUpdateFormValid: profileUpdateFormValid, profileBtnDisable: true },()=>{
                    if (this.timeoutInterval) {
                        clearTimeout(this.timeoutInterval);
                    }
                    this.timeoutInterval = setTimeout(() =>  {
                        this.formatData(event, controlError);
                    }, 500);
                });
            }
            this.saveDisable();
        })
    }

    saveDisable = () => {
        if (this.personalInfoData.firstname != this.state.profileUpdateForm.profile_firstname.value ||
            this.personalInfoData.lastname != this.state.profileUpdateForm.profile_lastname.value) {
            this.setState({
                isSaveDisable: false,
                modifieddatenamechange: true
            })
        } else {
            this.setState({
                isSaveDisable: true
            })
        }
    }
    checkDeleteUser = async () => {
        this.setState({
            deleteUserLoading: true
        })
        await axios.get(getAdminUrl(`${deleteUserValid}/${this.buyerId}`), getAdminHeaders())
            .then(response => {
                this.setState({
                    deleteModal: true,
                    deleteStatus: { show: false, type: '', message: '' },
                    deleteUserLoading: false
                })
                
            }).catch(error => {
                console.log(error.response.data.message)
                this.setState({
                    deleteModal: true,
                    deleteStatus: { show: true, type: 'danger', message: error.response.data.message },
                    deleteUserLoading: false
                })
                
            })
       
    }

    handleMouseEnter = () => {
        this.setState({ showTooltip: true });
    };

    handleMouseLeave = () => {
        this.setState({ showTooltip: false });
    };
    
    

    reactivateUser = () => {
        this.setState({
            ...this.state,
            showReactivateUserModel: true,
            reactive: {
                ...this.state.reactive,
                mobile: {
                    ...this.state.reactive.mobile,
                    value: this.state.form.mobile ?  mobileNumberFormat(this.state.form.mobile) : ''
                },
            },
        })
    }
    reactiveLog = (valid) => {
        if (valid) {
            this.setState({
                reactivelogLoader: true
            })

        }
        let data = {
            "data": {
                "buyerid": this.buyerId
            }
        }
        axios.post(getAdminUrl(buyerloglist), JSON.stringify(data), getAdminHeaders()).then((res) => {
            let actions = res.data.data[0]?.actions
            const reactivationLogs = actions && actions.filter(action => action.actionType === "REACTIVATION");
            this.setState({
                reactivateLogModel: valid,
                reactivateLog: reactivationLogs?.length > 0 ? reactivationLogs : [],
                reactivelogLoader: false

            })

        }).catch((error) => {

        })
    }

    phoneNumberOtpfn = (flag) => {
        this.setState({
            phoneNumberOtpBtn: false,
            otpAllow: true
        })

        const data = {
            "data": {
                "mobile": this.state.reactive.mobile.value.replace(/\D/g, ''),
                "otpvia": flag,
                "buyerid": this.buyerId,
            }
        };
        axios.post(getAdminUrl(mobileOtp), JSON.stringify(data), getAdminHeaders())
            .then(response => {


            })
            .catch(error => {

            });
    }

    reActivate = ()=>{

        const data ={
            "data": {
                "mobile": this.state.reactive.mobile.value.replace(/\D/g, ''),
                "email": this.state.reactive.email.value,
                "buyerid": this.buyerId,
            }
        };
        axios.post(getAdminUrl(reactivate), JSON.stringify(data), getAdminHeaders())
            .then(response => {
                this.setState({
                    reactivateMsg: 'Reactivation Mail Sent Successfully'
                })
                this.getBuyerDetail()

            })
            .catch(error => {
                this.setState({
                    messagetype: false,
                    reactivateMsg: error.response.data.message,
                })

            });

    }


    phoneNumberVerify = () => {

       this.setState({
        disablePhonenumberBtn: true
       })


        const data = {
            "data": {
                "mobile": this.state.reactive.mobile.value.replace(/\D/g, ''),
                "token": this.state.reactive.phoneNumberOtp.value,
                "buyerid": this.buyerId,

            }
        };
        this.setState({
            reactivateMsg: '',
            messagetype: true,
        })
        axios.post(getAdminUrl(otpVerify), JSON.stringify(data), getAdminHeaders())
            .then(response => {
                this.reActivate()
                setTimeout(() => {
                    this.reactiveLog(false)
                    this.setState({
                        disablePhonenumberBtn: false,
                        showReactivateUserModel: false,
                        phoneNumberOtpBtn: false,
                        allowPhoneNumber: true,
                        verifyPhonenumber: true,
                        allowEmail: false,
                        otpAllow: false,
                        reactivateMsg: '',
                        reactive: {
                            ...this.state.reactive,
                            phoneNumberOtp: {
                                ...this.state.reactive.phoneNumberOtp,
                                value: '',
                            },
                        }
                        
                    })
                }, 3000);
            })
            .catch(error => {
                this.setState({
                    messagetype: false,
                    disablePhonenumberBtn: false,
                    reactivateMsg: error.response.data.message,
                })

            });
    }

    handleCancel = () => {
        this.setState({
            ...this.state,
            showReactivateUserModel: false,
            phoneNumberOtpBtn: true,
            allowEmail: false,
            otpAllow: false,
            allowPhoneNumber: true,
            reactivateMsg: '',
            messagetype: true,
            disablePhonenumberBtn: false,
            reactive: {
                ...this.state.reactive,
                phoneNumberOtp: {
                    ...this.state.reactive.phoneNumberOtp,
                    value: '',
                },
                mobile: { 
                    ...this.state.mobile,
                    value: this.state.form.mobile,
                    validators: [Validators.required(), Validators.mobile()]
                },
                email:{
                    ...this.state.email,
                    value : this.state.form.email,
                    validators: [Validators.required(), Validators.email()]
                },
                formvalid: false,
            },
        },()=>{

        });
    };

    resendOtp = () => {
        this.setState({
            reactivateMsg: '',
            messagetype: true,
            resendOtpload: true,
        })
        const data = {
            "data": {
                "mobile": this.state.reactive.mobile.value.replace(/\D/g, ''),
                "otpvia": "sms",
                "buyerid": this.buyerId,
            }
        };
        axios.post(getAdminUrl(resendOtp), JSON.stringify(data), getAdminHeaders())
            .then(response => {
                
                this.setState({
                    reactivateMsg: 'Reset OTP sent Successfully',
                    resendOtpload: false,
                })
                setTimeout(() => {
                    this.setState({
                        ...this.state,
                        reactivateMsg: '',
                        reactive: {
                            ...this.state.reactive,
                            phoneNumberOtp: {
                                ...this.state.reactive.phoneNumberOtp,
                                value: '',
                            },
                        }

                    })
                    
                }, 1000);

            })
            .catch(error => {
                this.setState({
                    messagetype: false,
                    resendOtpload: false,
                    reactivateMsg:  error.response.data['message']

                })

            });
    }

    usermailcheck = (event) =>{
       
        this.setState({
            ...this.state,
            reactive: {
                ...this.state.reactive,
                email: event.target.value
            },
        })

    }
    phoneEmailValueCheck = (event) => {
        let  inputError = ''

       

        if (event.target.name == "mobile") {
            event.target.value = event.target.value.replace(/[^0-9()\s-]/g, '');
            const mobileValue = commonMobileNumberFormat(event.target.value, this.state.reactive.mobile.value);
            event.target.value = mobileValue ? mobileValue : event.target.value;
        }
        for (let validator of this.state.reactive[event.target.name].validators) {
              inputError = validator(event.target.value);
            if (inputError) break;
        }


        this.setState({
            ...this.state,
            emailVerify: true,
            reactive: {
                ...this.state.reactive,
                [event.target.name]: {
                    ...this.state.reactive[event.target.name],
                    value: event.target.value,
                    error: inputError
                },
                formvalid: Boolean(inputError)
            },
        },()=>{
            this.setState({ profileBtnDisable: true },()=>{
                if (this.timeoutInterval) {
                    clearTimeout(this.timeoutInterval);
                }
                this.timeoutInterval = setTimeout(() =>  {
                    this.formatData(event, inputError);
                }, 500);
            });
        })

    }

    formatData = (event, valid) => {

        const key = event.target.name === 'profile_firstname' ? 'firstname' : event.target.name  === 'profile_lastname' ? 'lastname'  :  event.target.name === 'newEmail' ? 'email' : event.target.name;
        if (!valid &&  event.target.value.length >= 2 ) {
            this.setState({
                apiLoading: true,
                profileBtnDisable: false
            });
            const data = {
                data: {
                    [key]: event.target.name == 'mobile' ? event.target.value.replace(/\D/g, '') : event.target.value,
                }
            };
            axios.post(getAdminUrl(buyerVerify), JSON.stringify(data), getAdminHeaders())
                .then(response => {
                    this.setState({
                        apiLoading: false
                    });
                    const result = response.data.data;
                        if (event.target.name === 'profile_firstname') {
                            this.setState({
                                ...this.state,
                                profile_firstname: false,
                         
                            })
                        }
                        if (event.target.name === 'profile_lastname') {
                            this.setState({
                                ...this.state,
                                profile_lastname: false,
                          
                            })
                        }
                        
                    
                    else {
                        if (result.valid) {
                            this.setState({
                                ...this.state,
                                showPhoneNumberModel: true,
                                reactive: {
                                    ...this.state.reactive,
                                    // formvalid: false
                                },
                            })
                        } else {
                            this.setState({
                                ...this.state,
                                reactive: {
                                    ...this.state.reactive,
                                    [event.target.name]: {
                                        ...this.state.reactive[event.target.name],
                                        error: result.message
                                    },
                                    formvalid: Boolean(result.message)
                                },
                            })

                        }
                    }

                })
                .catch(error => {
                    this.setState({
                        apiLoading: false
                    });
                    if (event.target.name === 'profile_firstname') {
                        this.setState({
                            ...this.state,
                            profile_firstname: true,
                            profileUpdateForm: {
                                ...this.state.profileUpdateForm,
                                profile_firstname: {
                                    ...this.state.profileUpdateForm.profile_firstname,
                                    error: error.response.data['message']
                                }
                            }
                        })
                    }
                    if (event.target.name === 'profile_lastname') {
                        this.setState({
                            ...this.state,
                            profile_lastname: true,
                            profileUpdateForm: {
                                ...this.state.profileUpdateForm,
                                profile_lastname: {
                                    ...this.state.profileUpdateForm.profile_lastname,
                                    error: error.response.data['message']
                                }
                            }
                        })
                    }
                    else if (event.target.name === 'newEmail') {
                        this.setState({
                            ...this.state,
                            [event.target.name]: {
                                ...this.state[event.target.name],
                                error: error.response.data['message']
                            },
                        })
                    }
                    else {
                        this.setState({
                            ...this.state,
                            reactive: {
                                ...this.state.reactive,
                                [event.target.name]: {
                                    ...this.state.reactive[event.target.name],
                                    error: error.response.data['message']
                                },
                                formvalid: Boolean(error.message)
                            },
                            emailVerify: false
                        })
                    }

                });
        }
    }

    otpCheck = (event) => {
        event.target.value = event.target.value.replace(/[^0-9\s]/g, '');
        this.setState({
            ...this.state,
            reactive: {
                ...this.state.reactive,
                [event.target.name]: {
                    ...this.state.reactive[event.target.name],
                    value: event.target.value
                },
            },
        })

    }

    


    cancelProfileAddress = () => {
        this.setState({
            addressNameCheckError: '',
            profileAddressModal: false,
            profileUpdateForm: {
                ...this.state.profileUpdateForm,
                profile_firstname: {...this.state.profileUpdateForm.profile_firstname, value: this.state.form.firstname, error: ''},
                profile_lastname: {...this.state.profileUpdateForm.profile_lastname, value: this.state.form.lastname, error: ''}
            },
            profileUpdateStatus:{ show: false, type: '', message: ''},
            profileUpdateFormValid: false
        })
    }

    openSuspendedModal = () => {
        if( this.state.form.buyerSuspendCount > 0 ){
        const suspendPostData = {
            'buyerid': this.buyerId,"locationid":this.state.suspensionlocationlist
        };
        axios.post(getSellerUrl(buyersuspendalllist), {"data" :suspendPostData}, getSellerHeaders())
            .then(response => {
                this.setState({
                    suspendList: response?.data?.data,
                    showSuspendedModal: true
                })
            })
            .catch(error => { });
        }
    }

    updateModifiedDate = () => {
        const buyerPostData = {
            field: ['id', 'firstname', 'lastname', 'email', 'mobile', 'emailverified', 'mobileverified','isDeleted','isreactivate',
                'total', 'active', 'address1', 'address2', 'zipcode', 'state', 'city', 'country','taxexemptdate', 'modifieddate', 'deletestatus',  "modifieddatename", "modifieddatenickname"]
        };
        
        axios.post(getSellerUrl(`${buyerdetail}/${this.buyerId}`), JSON.stringify(buyerPostData), getSellerHeaders()).then(response => {
            this.setState({
                form: {
                    ...this.state.form,
                    modifieddatename: response.data.data[0].modifieddatename,
                    deleteProgressStatus: response?.data?.data[0]?.deletestatus ? JSON.parse(response.data.data[0].deletestatus): {}
                }
            });
            this.personalInfoData = {
                firstname: response.data.data[0].firstname,
                lastname: response.data.data[0].lastname
            }
        })
    }
    
    openUnSuspendedModal = () => {
        if(this.state.form.unsuspendedcount  > 0){
        const unsuspendPostData = {
            'buyerid': this.buyerId,"locationid":this.state.unsuspensionlocationlist
        };
        axios.post(getSellerUrl(buyerunsuspendalllist), {"data" :unsuspendPostData}, getSellerHeaders())
            .then(response => {
                this.setState({
                    unsuspendList: response?.data?.data,
                    unsuspensionModal: true
                })
            })
            .catch(error => { });
        }
    }

    /* Enable unsuspend reason modal */
    setUnSuspendReasonModal = () => {
        this.setState({
            form: {
                ...this.state.form,
                unsuspendReason: {
                    ...this.state.form.unsuspendReason,
                    unsuspendReasonModal: false,
                },
            },
            unsuspendModal: true
        });
    }

    openUnSuspendedReasonModal = (value) => {
        this.setState({
            form: {
                ...this.state.form,
                unsuspendReason: {
                    ...this.state.form.unsuspendReason,
                    unsuspendReasonModal: value
                }
            }   
        })
    }

    logoutUser = () => {
        this.setState({
            signOutLoading: true,
            signoutDisabled: true,
            textSuccess: false,
        })
        let data = {
            data: {
                "buyerid": this.buyerId
            }
        }
        axios.post(getAdminUrl(logoutUser), JSON.stringify(data), getAdminHeaders())
            .then(response => {
                this.setState({
                    textSuccess: true,
                    signoutMessage: 'User logged out successfully from all signed in devices.',
                    signOutLoading: false,

                })
                setTimeout(() => {
                    this.setState({
                        signoutDisabled: false,
                        signoutMessage: '',
                        signOutModal: false
                    })
                }, 3000)
            }).catch(error => {
                this.setState({
                    signoutMessage: error?.response?.data?.message,
                    signOutLoading: false,
                    signoutDisabled: false,
                    textSuccess: false
                })
            })

    }

    /* resend suspend data when cancel */
    resetUnSuspend = () => {
        this.setState({
            ...this.state,
            unsuspendModal: false,
            unsuspendedLocationList: this.locationOptions,
            form: {
                ...this.state.form,
                filteredsuspendedLocations: this.state.suspendedLocationList,
                unsuspend: { 
                ...this.state.form.unsuspend,
                locationid: { value: [], error: '', valid: false },
                selectedAll: false,
                selectedLocation: '', 
                valid: false
                },
                unsuspendReason: {
                    locationid: { value: [], error: '', valid: false },
                    revokereason: { value: '', error: '', valid: false, validators: [Validators.required()] },
                    selectedAll: false,
                    selectedLocation: '',
                    valid: false,
                    unsuspendReasonModal: false,
                    revoketype: { value: '', error: '', valid: false, validators: [Validators.required()] },
                    alllocation: false,
                }
            },
            unsuspendList: []
        })
    }

    render() {
        if (this.state.errorpageredirect) {
            // redirect to Not-Found if wrong Buyerid
            return <NoData {...this.props} type={this.state.errorType} />
        }
        return (
            <div style={{ overflow: "auto", overflowY: "overlay" }}>
                {this.state.loading ?
                    <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100" style={{ padding: "30%" }}>
                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                    </div> :
                    <div>
                        <div id="backbutton" style={{ borderBottom: "1px solid #b6b6b6", padding: "1%" }}>
                            <span onClick={this.navigateToList} className="clickable">
                                <i className="fa fa-chevron-circle-left fa-lg text-back rounded-circle"></i>
                                <span style={{ paddingLeft: "1em" }}>Back</span>
                            </span>
                            <span className="text-secondary ml-2 pl-3" style={{ borderLeft: "1px solid" }}>{this.state.form.lastname},{this.state.form.firstname}</span>
                        </div>

                        <div className="buyerClass">
                            
                            <div className="px-3 buyerDetail mt-3">
                            <div className="mt-3" style={{fontWeight:'bold', fontSize:'15px', textAlign:'left'}}>
                                Profile :
                                <span className='border-set' style={{ width:'50px' }}></span>
                            </div>
                                <Row className="buyer-profile-row">
                                    <Col className="buyer-profile-column py-3">
                                        <label>Name</label>
                                        <p>{this.state.form.lastname}, {this.state.form.firstname}</p>
                                        {/* <label style={{ whiteSpace: "nowrap", marginTop: '10%' }}>Tax Exemption Submission Date:</label>
                                        <p>{this.state.form.taxexemptdate ? this.getSignupDatetime(this.state.form.taxexemptdate) : '- - -'}</p> */}
                                    </Col>
                                    <Col className="buyer-profile-column py-3">
                                        <label>Sign Up Date</label>
                                        <p style={{ wordBreak: "break-word" }}>{this.state.form.signupdate ? this.getSignupDatetime(this.state.form.signupdate) : '- - -'}</p>
                                    </Col>
                                    <Col className="buyer-profile-column py-3">
                                        <label>Name Change Last Modified Date</label>
                                        <p style={{ wordBreak: "break-word" }}>{this.state.form.modifieddatename ? this.getSignupDatetime(this.state.form.modifieddatename) : '- - -'}</p>
                                    </Col>
                                    <Col className="buyer-profile-column py-3">
                                        <div className="d-flex flex-row">
                                            <label>Email</label>
                                            <span className="ml-2">
                                                <Button className="btn-email buyer-email" disabled={this.state.form.active === 0 || this.state.form.isReactive} onClick={this.showEmailModal}>
                                                    Click here to change Email
                                                </Button>
                                            </span>
                                        </div>
                                        <p>{this.state.form.email ? this.state.form.email : '- - -'}</p>
                                        <div className='d-flex'>
                                            <p>{this.state.form.email ? this.state.form.isEmailVerfied ? <span className="text-success">Verified </span> : <span className="text-warning">Not Verified</span> : '- - -'}</p>
                                            
                                            {this.state.form.showGoogle && <div className='social-media-icon'>
                                                <img src={`${process.env.PUBLIC_URL}/static/images/google.svg`} alt="google icon" width={"25px"} />
                                            </div>}
                                            {this.state.form.showFacebookd && <div className='social-media-icon'>
                                                <img src={`${process.env.PUBLIC_URL}/static/images/facebook.svg`} alt="facebook icon" width={"25px"} />
                                            </div>}
                                            {this.state.form.showApple && <div className='social-media-icon'>
                                                <img src={`${process.env.PUBLIC_URL}/static/images/apple.svg`} alt="apple icon" width={"25px"} />
                                            </div>}
                                        </div>
                                    </Col>
                                    <Col className="buyer-profile-column py-3">
                                        <label>Phone</label>
                                        <p>{this.state.form.mobile ? this.state.form.mobile : '- - -'}</p>
                                        <p>{this.state.form.mobile ? this.state.form.isMobileVerfied ? <span className="text-success">Verified </span> : <span className="text-warning">Not Verified</span> : ''}</p>

                                    </Col>
                                    <Col className="buyer-profile-column py-3">
                                        <label>User Name</label>
                                        <p style={{ wordBreak: "break-word" }}> { this.state.form.membershipCompleted && this.state.form.nickname   ?  <img src={`${process.env.PUBLIC_URL}/static/images/membership.png`} alt="" width={'20px'}  />: '' } {this.state.form.nickname ? this.state.form.nickname : '- - -'}  </p>
                                    </Col>
                                    <Col className="buyer-profile-column py-3">
                                        <label>Reactivation request status</label>
                                        {!this.state.form.isReactive && this.state.form.reactivationDate ? (
                                            <p style={{ wordBreak: "break-word", color: "green" }}>Completed</p>
                                        ) : this.state.form.reactivationDate && this.state.form.active ? (
                                            <p style={{ wordBreak: "break-word", color: "#a50050" }}>In progress</p>
                                        ) : (
                                            <p style={{ wordBreak: "break-word" }}>- - -</p>
                                        )}                                       

                                    </Col>
                                    <Col className="buyer-profile-column py-3">
                                        <label>Reactivation request date</label>
                                        <p style={{ wordBreak: "break-word" }}> {  this.state.form.reactivationDate ? this.getSignupDatetime(this.state.form.reactivationDate) : '- - -'}  </p>
                                    </Col>
                            
                                  
                                    {/* <Col className="py-3"> */}
                                    {/* <label>Total purchased to Date</label>
                                    <p>{this.state.form.total ? `${this.state.form.total}` : '- - -'}{this.state.form.pending ? `. [${this.state.form.pending} Pending]` : ''}</p> */}
                                    {/* <div style={{height: "20px"}}></div>
                                    <div className="w-100 d-flex">
                                        <Button className="btn mt-4" style={{ height: "fit-content", height: "-moz-fit-content",marginTop:'15px',backgroundColor: "#129A4E",color: "#FFFFFF"}} onClick={() => this.setState({resetModal:true})}>Reset Password</Button>
                                    </div>   */}
                                    {/* </Col> */}
                                   
                                </Row>
                                <div className='buyer-profile-summary d-flex'>
                                    <div className='w-75 buyer-profile-summary-compliance'>
                                        <div className="mb-3 mt-3" style={{ fontWeight: 'bold', fontSize: '15px', textAlign: 'left' }}>
                                        Consumer Rights & Compliance :
                                            <span className='border-set' style={{ width: '180px' }}></span>
                                        </div>
                                        <Row style={{ marginBottom: '10px', marginTop: '20px' }}>
                                         
                                            <Col>
                                            <label>Created Date</label>
                                            <p style={{ wordBreak: "break-word" }}> {  this.state.caDetails?.createdDate ? this.getSignupDatetime(this.state.caDetails.createdDate) : '- - -'}  </p>
                                            </Col>
                                            <Col>
                                            <label>Request</label>
                                            <p style={{ wordBreak: "break-word" }}> {   this.state.caDetails?.righttype ?  this.state.caDetails.righttype : '- - -'}  </p>
                                            </Col>
                                            <Col>
                                            <label>Status</label>
                                            <p style={{ wordBreak: "break-word" }}> {   this.state.caDetails?.status ? capitalizeFirstLetter(this.state.caDetails.status) : '- - -'}  </p>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className='buyer-profile-summary-payment' style={{width: '35%'}}>
                                        <div className="mb-3 mt-3" style={{ fontWeight: 'bold', fontSize: '15px', textAlign: 'left' }}>
                                            Payment Method Details:
                                            <span className='border-set' style={{ width: '180px' }}></span>
                                        </div>
                                        <Row style={{ marginBottom: '10px', marginTop: '20px' }}>
                                            <Col>
                                                <label>Active</label>
                                                <p>{this.state.form.activeCount}</p>
                                            </Col>
                                            <Col>
                                                <label>In Active</label>
                                                <p>{this.state.form.inActiveCount}</p>
                                            </Col>
                                            

                                        </Row>
                                    </div>
                                </div>
                                
                                <div className="mb-3 mt-3"  style={{fontWeight:'bold', fontSize:'15px', textAlign:'left'}}>
                                    Address :
                                    <span className='border-set' style={{ width:'60px' }}></span>
                              </div>
                              <div className='address-table-header'>
                                <div className='address-table' >
                                <Row className='mb-3' style={{ fontWeight:'bold'}}>
                                    <Col>
                                        Address Type
                                    </Col>
                                    <Col>
                                        Address Line 1
                                    </Col>
                                    <Col>
                                        Address Line 2
                                    </Col>
                                    <Col>
                                         City
                                    </Col>
                                    <Col>
                                        State
                                    </Col>
                                    <Col>
                                        Zip Code
                                    </Col>
                                    <Col>
                                        Last Modified Date
                                    </Col>
                                </Row>
                                <Row className='mb-2'>
                                    <Col>
                                        {"Primary"}
                                    </Col>

                                    <Col style={{wordBreak:'break-word'}}>
                                        {this.state?.primaryAddr?.address1 ? this.state?.primaryAddr?.address1 : "- - -"}</Col>

                                    <Col style={{wordBreak:'break-word'}}>
                                        {this.state?.primaryAddr?.address2 ? this.state?.primaryAddr?.address2 : "- - -"}</Col>

                                    <Col>
                                        {(this.state?.primaryAddr?.city ? this.state?.primaryAddr?.city : '- - -') }
                                    </Col>
                                    <Col>
                                        {(this.state?.primaryAddr?.state ? this.state?.primaryAddr?.state : '- - -')}
                                    </Col>
                                    <Col>

                                        {(this.state?.primaryAddr?.zipcode ? this.state?.primaryAddr?.zipcode : '- - -')}
                                    </Col>
                                    <Col>
                                        {this.state?.primaryAddr?.modifieddate ? this.getSignupDatetime(this.state?.primaryAddr?.modifieddate ) : '- - -'}
                                    </Col>
                                </Row> 
                                <Row className='mt-3'>
                                    <Col>
                                        {"Shipping"}
                                    </Col>

                                    <Col style={{wordBreak:'break-word'}}>
                                        {this.state?.shippingAddr?.address1 ? this.state.shippingAddr?.address1 : "- - -"}</Col>

                                    <Col style={{wordBreak:'break-word'}}>
                                        {this.state?.shippingAddr?.address2 ? this.state.shippingAddr?.address2 : "- - -"}</Col>

                                    <Col>
                                        {(this.state?.shippingAddr?.city ? this.state?.shippingAddr?.city :  "- - -") }
                                    </Col>
                                    <Col>
                                        {(this.state?.shippingAddr?.state ? this.state?.shippingAddr?.state :  "- - -")}
                                    </Col>
                                    <Col>

                                        {(this.state?.shippingAddr?.zipcode ? this.state?.shippingAddr?.zipcode :  "- - -")}
                                    </Col>
                                    <Col>
                                         {this.state?.shippingAddr?.modifieddate ? this.getSignupDatetime(this.state?.shippingAddr?.modifieddate ) : '- - -'}
                                    </Col>
                                </Row> 
                                        <Row className='mt-3'>
                                            <Col>
                                                {"Payment"}
                                            </Col>

                                            <Col style={{ wordBreak: 'break-word' }}>
                                                {this.state?.paymentAddr?.address1 ? this.state.paymentAddr?.address1 : "- - -"}</Col>

                                            <Col style={{ wordBreak: 'break-word' }}>
                                                {this.state?.paymentAddr?.address2 ? this.state.paymentAddr?.address2 : "- - -"}</Col>

                                            <Col>
                                                {(this.state?.paymentAddr?.city ? this.state?.paymentAddr?.city : "- - -")}
                                            </Col>
                                            <Col>
                                                {(this.state?.paymentAddr?.state ? this.state?.paymentAddr?.state : "- - -")}
                                            </Col>
                                            <Col>

                                                {(this.state?.paymentAddr?.zipcode ? this.state?.paymentAddr?.zipcode : "- - -")}
                                            </Col>
                                            <Col>
                                                {this.state?.paymentAddr?.modifieddate ? this.getSignupDatetime(this.state?.paymentAddr?.modifieddate) : '- - -'}
                                            </Col>
                                        </Row>
                                    </div>

                                    <div className='address-table-header'>
                                      
                                            <div className="mb-3 mt-3" style={{ fontWeight: 'bold', fontSize: '15px', textAlign: 'left' }}>
                                                Other Address's on Profile :
                                                <span className='border-set' style={{ width: '192px' }}></span>
                                            </div>
                                            
                                        <div className='address-table'>
                                            <Row className='mb-3' style={{ fontWeight: 'bold' }}>
                                                <Col>Address Type</Col>
                                                <Col>Address Line 1</Col>
                                                <Col>Address Line 2</Col>
                                                <Col>City</Col>
                                                <Col>State</Col>
                                                <Col>Zip Code</Col>
                                                <Col>Last Modified Date</Col>
                                            </Row>
                                           {this.state?.buyeradditionalAddressList ?  <>

                                            {this.state?.buyeradditionalAddressList?.map((address, index, arr) => (
                                                <Row className="mb-3" key={index}>
                                                    <Col> {address?.addresstype ? this.getAddressTypeWithCount(address, index, arr) : "- - -"} </Col>

                                                    <Col style={{ wordBreak: "break-word" }}>
                                                        {address?.address1 || "- - -"}
                                                    </Col>

                                                    <Col style={{ wordBreak: "break-word" }}>
                                                        {address?.address2 || "- - -"}
                                                    </Col>

                                                    <Col>{address?.city || "- - -"}</Col>

                                                    <Col>{address?.state || "- - -"}</Col>

                                                    <Col>{address?.zipcode || "- - -"}</Col>

                                                    <Col>
                                                        {address?.modifieddate
                                                            ? this.getSignupDatetime(address.modifieddate)
                                                            : "- - -"}
                                                    </Col>
                                                </Row>
                                            ))}
                                            </> : 
                                            <Row className="mb-3" >
                                                    <Col>{"- - -"}</Col>
                                                    <Col>{"- - -"}</Col>
                                                    <Col>{"- - -"}</Col>
                                                    <Col>{"- - -"}</Col>
                                                    <Col>{"- - -"}</Col>
                                                    <Col>{"- - -"}</Col>
                                                    <Col>{"- - -"}</Col>
                                                </Row> }
                                        </div>

                                    </div>

                                </div>
                                {/* <Row>

                                    <Col></Col>
                                    <Col> </Col>
                                    <Col>

                                        {this.state.isSuspended || !this.state.unsuspendedLocationList.length ? <div className="text-danger">Buyer Suspended</div> : ''}
                                        <Button className="btn w-100 suspendButton" style={this.state.disableSuspend ? {  backgroundColor: "#999999", borderColor: "#999999", color: "black", opacity: 0.5 } : { backgroundColor: "white", borderColor: "#29B0FF", color: "#29B0FF" }} disabled={!this.state.unsuspendedLocationList.length || this.state.form.active === 0} onClick={() => this.setSuspendModal()}>Suspend Buyer</Button>

                                    </Col>
                                    <Col>
                                         <Button className="btn w-100  suspendButton" style={{ backgroundColor: "white", borderColor: "#FF0000", color: "#FF0000" }} disabled={!this.state.form.filteredsuspendedLocations.length || this.state.form.active === 0} onClick={() => this.setUnSuspendModal()}>UnSuspend Buyer</Button>
                                    </Col>
                                    
                                    <Col>
                                        {this.state.form.buyerSuspendCount > 0 &&
                                            <Button className="mt-2 w-100"
                                                style={{
                                                    height: "fit-content", height: "-moz-fit-content",
                                                }
                                                } disabled={true}
                                            >Suspended{` - ${this.state.form.buyerSuspendCount}`}</Button>}
                                    </Col>

                                    <Col></Col>
                                </Row> */}
                                {Object.keys(this.state.form.deleteProgressStatus).length > 0 && this.state.form.deleterequest?
                                    <><Row className='d-flex mb-3 mt-5'>
                                        <Col><b className='border-set mb-3' style={{ width: '155px' }}>Delete Request Status:</b></Col>
                                        <Col></Col>
                                        {Object.keys(this.state.form.deleteProgressStatus).length > 0 ?
                                            <div className='steps-container step-style mb-3'>
                                                <div className='steps'>
                                                    <span className={`circle ${this.state.form.deleteProgressStatus?.ctbids?.status == 'COMPLETED' || this.state.form.deleteProgressStatus?.ctbids?.status == 'SUCCESS' ? "progress-success" : "progress-failed"}`}>
                                                        {this.state.form.deleteProgressStatus?.ctbids?.status == 'COMPLETED' || this.state.form.deleteProgressStatus?.ctbids?.status == 'SUCCESS' ?
                                                            <div>
                                                                <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{this.state.form.deleteProgressStatus.ctbids.message}</Tooltip>}>
                                                                    <span>✔</span>
                                                                </OverlayTrigger>
                                                            </div> :
                                                            this.state.form.deleteProgressStatus?.ctbids?.status == 'INITIATED' || this.state.form.deleteProgressStatus?.ctbids?.status == 'PENDING' || this.state.form.deleteProgressStatus?.ctbids?.status == 'FAILED' ?
                                                                <div>
                                                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{this.state.form.deleteProgressStatus.ctbids.message ? this.state.form.deleteProgressStatus.ctbids.message : "CTBIDS deletion process inprogress"}</Tooltip>}>
                                                                        <span>!</span>
                                                                    </OverlayTrigger>
                                                                </div> : 1}
                                                    </span>
                                                    <span className={`circle ${this.state.form.deleteProgressStatus?.paymentMethod?.status == 'COMPLETED' || this.state.form.deleteProgressStatus?.paymentMethod?.status == 'SUCCESS' ? "progress-success" : "progress-failed"}`}>
                                                        {this.state.form.deleteProgressStatus?.paymentMethod?.status == 'COMPLETED' || this.state.form.deleteProgressStatus?.paymentMethod?.status == 'SUCCESS' ?
                                                            <div>
                                                                <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{this.state.form.deleteProgressStatus.paymentMethod.message}</Tooltip>}>
                                                                    <span>✔</span>
                                                                </OverlayTrigger>
                                                            </div> : this.state.form.deleteProgressStatus?.paymentMethod?.status == 'INITIATED' || this.state.form.deleteProgressStatus?.paymentMethod?.status == 'PENDING' || this.state.form.deleteProgressStatus?.paymentMethod?.status == 'FAILED' ?
                                                                <div>
                                                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{this.state.form.deleteProgressStatus.paymentMethod.message ? this.state.form.deleteProgressStatus.paymentMethod.message : "Payment Method deletion process inprogress"}</Tooltip>}>
                                                                        <span>!</span>
                                                                    </OverlayTrigger></div> : 2}
                                                    </span>
                                                    <span className={`circle ${this.state.form.deleteProgressStatus?.franConnect?.status == 'COMPLETED' || this.state.form.deleteProgressStatus?.franConnect?.status == 'SUCCESS' ? "progress-success" : "progress-failed"}`}>
                                                        {this.state.form.deleteProgressStatus?.franConnect?.status == 'COMPLETED' || this.state.form.deleteProgressStatus?.franConnect?.status == 'SUCCESS' ?
                                                            <div>
                                                                <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{this.state.form.deleteProgressStatus.franConnect.message}</Tooltip>}>
                                                                    <span>✔</span>
                                                                </OverlayTrigger>
                                                            </div> : this.state.form.deleteProgressStatus?.franConnect?.status == 'INITIATED' || this.state.form.deleteProgressStatus?.franConnect?.status == 'PENDING' || this.state.form.deleteProgressStatus?.franConnect?.status == 'FAILED' ?
                                                                <div>
                                                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{this.state.form.deleteProgressStatus.franConnect.message ? this.state.form.deleteProgressStatus.franConnect.message : "FranConnect deletion process inprogress"}</Tooltip>}>
                                                                        <span>!</span>
                                                                    </OverlayTrigger></div> : 3}
                                                    </span>
                                                    <div className='progress-bar'>
                                                        <span className='indicator'></span>
                                                    </div>
                                                </div>
                                            </div> : ''}
                                        <Col></Col>
                                        <Col></Col>
                                    </Row><Row className='d-flex'>
                                            <Col></Col>
                                            <Col></Col>
                                            <div className='steps-container step-content '>
                                                <div className='steps'>
                                                    <span>CTBIDS</span>
                                                    <span style={{ margin: "0px 0px 0px 25px" }}>PayPal</span>
                                                    <span>Franconnect</span>
                                                </div>
                                            </div>
                                            <Col></Col>
                                            <Col></Col>
                                        </Row></> : ''}
                                        <Row>

                                        </Row>
                                <Row className="buyer-actions-row mt-3 mb-3">
                                    <Col xs={12} sm={6} md className="buyer-actions-column">
                                        <div className="w-100 d-flex">
                                            <Button className="btn buyer-action-button mt-4" style={{ height: "fit-content", height: "-moz-fit-content", marginTop: '15px', backgroundColor: "#1d8296", color: "#FFFFFF" }} disabled={this.state.form.active === 0} onClick={() => this.updateProfile()}>Update Profile</Button>
                                        </div>
                                    </Col>
                                    {this.state.form.isDeleted || this.state.form.isReactive ? <Col xs={12} sm={6} md className="buyer-actions-column">
                                        <div className="w-100 d-flex">
                                        <Button className="btn buyer-action-button mt-4" style={{ height: "fit-content", height: "-moz-fit-content", marginTop: '15px', backgroundColor: "#A50050", color: "#FFFFFF" }} disabled={(this.state.form.active === 0 && this.state.form.profilecompleted === 0) || this.state.form.suspensionstatus === "ALL"} onClick={() => this.reactivateUser()}>Reactivate  {this.state.deleteUserLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''} </Button>
                                        </div>
                                    </Col> :
                                        <>
                                            <Col xs={12} sm={6} md className="buyer-actions-column">

                                                <div className="w-100 d-flex">
                                                <Button className="btn buyer-action-button mt-4" style={{ height: "fit-content", height: "-moz-fit-content", marginTop: '15px', backgroundColor: "#A50050", color: "#FFFFFF" }} disabled={this.state.form.active === 0 || this.state.deleteUserLoading} onClick={() => this.checkDeleteUser()}>Delete User {this.state.deleteUserLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''} </Button>
                                                </div>
                                            </Col>
                                           
                                        </>
                                    }
                                     <Col xs={12} sm={6} md className="buyer-actions-column">
                                        <div className="w-100 d-flex">
                                            <Button className="btn buyer-action-button mt-4" style={{ height: "fit-content", height: "-moz-fit-content", marginTop: '15px', backgroundColor: "#A50050", color: "#FFFFFF" }} disabled={this.state.reactivelogLoader || this.state.reactivateLog.length === 0}   onClick={() => this.reactiveLog(true)}>Reactive Log{this.state.reactivelogLoader ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''} </Button>
                                        </div>
                                    </Col>  

                                    <Col xs={12} sm={6} md className="buyer-actions-column">
                                        <div className="w-100 d-flex">
                                            <Button className="btn buyer-action-button mt-4" style={{ height: "fit-content", height: "-moz-fit-content", marginTop: '15px', backgroundColor: "#1d8296", color: "#FFFFFF" }} disabled={this.state.form.active === 0 || !this.state.form.isEmailVerfied} onClick={() => this.resetPasswordfn()}>Reset Password</Button>
                                        </div>
                                    </Col>
                                    <Col> </Col>
                                </Row>
                                <Row className='buyer-actions-row pb-5'>
                                <Col xs={12} sm={6} md className="buyer-actions-column d-flex mt-3">
                                        <div className="w-100 d-flex">
                                            {/* {this.state.isSuspended || !this.state.unsuspendedLocationList.length ? <p className="text-danger">Buyer Suspended</p> : ''} */}
                                            <Button className="btn buyer-action-button suspendButton" style={this.state.disableSuspend ? { height: "fit-content", height: "-moz-fit-content", backgroundColor: "#00263E", borderColor: "#00263E", color: "black", opacity: 0.5 } : { height: "fit-content", height: "-moz-fit-content", backgroundColor: "#00263E", borderColor: "##00263E",  whiteSpace: 'nowrap' }} disabled={!this.state.unsuspendedLocationList.length || this.state.form.active === 0} onClick={() => this.setSuspendModal(true)}>Suspend Buyer</Button>
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={6} md className='buyer-actions-column d-flex mt-3'>
                                        <div className="w-100 d-flex">
                                            <Button className="btn buyer-action-button suspendButton" style={{ height: "fit-content", height: "-moz-fit-content", backgroundColor: "white", borderColor: "#FF0000", color: "#FF0000", whiteSpace: 'nowrap' }} disabled={!this.state.form.filteredsuspendedLocations.length || this.state.form.active === 0} onClick={() => this.openUnSuspendedReasonModal(true)}>UnSuspend Buyer</Button>
                                        </div>
                                    </Col>
                                     <Col xs={12} sm={6} md className="buyer-actions-column d-flex mt-3">
                                        <div className="w-100 d-flex">
                                            <Button variant="secondary" className="btn buyer-action-button" style={{ height: "fit-content", height: "-moz-fit-content", backgroundColor: "#A50050", color: "#FFFFFF" }} disabled={this.state.form.active === 0} onClick={() => this.setState({ signOutModal: true })}>Sign User Out</Button>
                                        </div>
                                    </Col>

                                    <Col xs={12} sm={6} md className='buyer-actions-column d-flex align-items-end suspended-section'>
                                        <div style={{ marginBottom: "5px", marginRight: "5px" }}>Suspended</div> 
                                        <div className={`d-flex flex-row justify-content-center align-items-center border bg-white ${this.state.form.buyerSuspendCount > 0 ? 'clickable' : ''}`}
                                            style={{ borderRadius: "50%", height: "30px", width: "30px" }} onClick={this.openSuspendedModal}>
                                            {
                                                this.state.form.buyerSuspendCount ?
                                                    <span style={{ marginTop: "1px" }}>{this.state.form.buyerSuspendCount}</span> :
                                                    <span style={{ marginTop: "1px" }}>0</span>
                                            }
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={6} md className='buyer-actions-column d-flex align-items-end suspended-section'>
                                        <div style={{ marginBottom: "5px", marginRight: "5px" }}>UnSuspension's</div> 
                                        <div className={`d-flex flex-row justify-content-center align-items-center border bg-white ${this.state.form.unsuspendedcount > 0 ? 'clickable' : ''}`}
                                            style={{ borderRadius: "50%", height: "30px", width: "30px" }} onClick={this.openUnSuspendedModal}>
                                            {
                                                this.state.form.unsuspendedcount ?
                                                    <span style={{ marginTop: "1px" }}>{this.state.form.unsuspendedcount}</span> :
                                                    <span style={{ marginTop: "1px" }}>0</span>
                                            }
                                        </div>
                                    </Col>

                                </Row>
                            </div>

                            <div className="px-3 buyerDetail mt-3">
                                <div className='d-flex justify-content-between'>
                                    <div className="mb-3 mt-3" style={{ fontWeight: 'bold', fontSize: '15px', textAlign: 'left' }}>
                                        Bidding Details :
                                        <span className='border-set' style={{ width: '110px' }}></span>
                                    </div>

                                    <div className="d-flex flex-column p-2">
                                        <Form style={{ textAlign: "flex-end" }}>
                                            <Form.Control as="select" name="buyerLocation" id="buyerLocation" defaultValue={this.state.searchLocationId} className="float-left" style={{ width: "100%" }} onChange={(event) => this.enableSearch(event)}>
                                                <option value='' key="all">All Locations</option>
                                                {
                                                    this.state.locations.map(location =>
                                                        <option value={location.id} key={location.id}>{location.title}</option>
                                                    )
                                                }
                                            </Form.Control>
                                        </Form>
                                    </div>
                                </div>
                                           
                                <Row className='mb-2'>
                                    {/* <Col className="py-3">
                                        <p>Bidder Status</p>
                                        {this.state.isSuspended ? <p className="text-danger">Buyer Suspended</p> : '---'}
                                    </Col > */}
                                    <Col className="py-3">
                                        <p>Items Won </p>
                                        {this.state.form.bidWonCount || this.state.form.bidWonCount === 0 ? this.state.form.bidWonCount : '- - -'}
                                    </Col >
                                    <Col className="py-3">
                                        <p>Invoices Paid</p>
                                        {this.state.form.invoicepaidcount || this.state.form.invoicepaidcount === 0 ? this.state.form.invoicepaidcount : '- - -'}
                                    </Col>
                                    <Col className="py-3">
                                        <p>Invoices Unpaid</p>
                                        {(this.state.form.invoiceunpaidcount || this.state.form.invoiceunpaidcount === 0 ? this.state.form.invoiceunpaidcount : '- - -')}
                                    </Col>
                                    <Col className="py-3">
                                        <p>Items Currently Bidding</p>
                                        {(this.state.form.itemBidCount || this.state.form.itemBidCount === 0 ? this.state.form.itemBidCount : '- - -')}
                                    </Col>
                                </Row>
                                {/* <Row>
                                    <Col>{this.state.form.bidWonCount || this.state.form.bidWonCount === 0 ? this.state.form.bidWonCount : '-'}</Col>
                                    <Col>{this.state.form.invoicepaidcount || this.state.form.invoicepaidcount === 0 ? this.state.form.invoicepaidcount : '-'}</Col>
                                    <Col>{(this.state.form.invoiceunpaidcount || this.state.form.invoiceunpaidcount === 0 ? this.state.form.invoiceunpaidcount : '-')}</Col>
                                    <Col>{(this.state.form.itemBidCount || this.state.form.itemBidCount === 0 ? this.state.form.itemBidCount : '')}</Col>
                                </Row> */}
                                <div className="mb-3 mt-3" style={{fontWeight:'bold', fontSize:'15px', textAlign:'left'}}>
                                    Tax :
                                    <span className='border-set' style={{ width:'30px' }}></span>
                                </div>
                                <Row style={{ marginBottom: '20px', marginTop: '20px' }}>
                                    <Col>
                                        {/* <label style={{ whiteSpace: 'nowrap' }}>Tax Exemption Submission Date:</label>
                                        <p>{this.state.form.taxexemptdate ? this.getSignupDatetime(this.state.form.taxexemptdate) : '- - -'}</p> */}
                                    </Col>
                                    <Col> </Col>
                                    <Col></Col>
                                    <Col>
                                        {this.state.buttonText && this.state.searchLocationId ? <Button className="mt-2 w-100" style={{ whiteSpace: 'nowrap', height: "fit-content", height: "-moz-fit-content", borderColor: this.state.taxexemptColor === 'white' ? 'black' : this.state.taxexemptColor, backgroundColor: this.state.taxexemptColor, color: this.state.taxexemptColor === 'white' ? 'black' : 'white' }} disabled={this.state.form.active === 0} onClick={() => this.navigateTaxExemption()} >{this.state.buttonText}</Button> : ''}
                                    </Col>
                                    <Col></Col>
                                    <Col></Col>
                                    <Col></Col>
                                    <Col></Col>
                                    <Col></Col>
                                </Row>
                            </div>

                            <div className="px-3 buyerDetail mt-3 mb-3">
                                <div className='d-flex justify-content-between'>
                                    <div className="mb-3 mt-3" style={{ fontWeight: 'bold', fontSize: '15px', textAlign: 'left' }}>
                                        Premier Membership :
                                        <span className='border-set' style={{ width: '160px' }}></span>
                                    </div>
                                </div>

                                <Row className='mb-2'>

                                    <Col className="py-3">
                                        <p>Membership Status</p>
                                        {this.state.form.membershipDetails.membershipStatus ? capitalizeFirstLetter(this.state.form.membershipDetails.membershipStatus) : '- - -'}

                                    </Col >
                                    <Col className="py-3">
                                        <p style={{  whiteSpace: 'nowrap' }}>T&C Agreement Date </p>
                                        {this.state.form.membershipDetails.membershipStartDate ? this.getSignupDatetime(this.state.form.membershipDetails.membershipStartDate) : '- - -'}

                                    </Col>
                                    <Col className="py-3">
                                        <p style={{ whiteSpace: 'nowrap' }}>Premier Enrollment Start Date</p>
                                        {this.state.form.membershipDetails.membershipStartDate ? this.getSignupDatetime(this.state.form.membershipDetails.membershipStartDate) : '- - -'}

                                    </Col>
                                    <Col className="py-3">
                                        <p style={{ whiteSpace: 'nowrap' }} >Premier Enrollment End Date</p>
                                        {this.state.form.membershipDetails.membershipEndDate ? this.timeformateChange(this.state.form.membershipDetails.membershipEndDate) : '- - -'}

                                    </Col>
                                    <Col className="py-3">
                                        <p>Membership Invoice</p>
                                        {this.state.form.membershipDetails.membershipInvoiceNumber ? <p style={{ cursor: 'pointer',textDecoration: 'underline', textDecorationColor: '#A50050', fontWeight: 'bold'}} onClick={()=>{this.setState({ membershipInvoiceModal: true })}}> { this.state.form.membershipDetails.membershipInvoiceNumber}</p>  : '- - -'}
                                    </Col>
                                </Row>
                                <Row className='mb-2'>

                                    <Col className="py-3">
                                        <p>Available Credits</p>
                                        {this.state.form.membershipDetails.membershipCreditsAvailable || this.state.form.membershipDetails.membershipCreditsAvailable === 0 ? <p > { this.state.form.membershipDetails.membershipCreditsAvailable}</p>  : '- - -'}
                                    </Col >
                                    <Col className="py-3">
                                        <p style={{ whiteSpace: 'nowrap' }}>Pending Credits</p>
                                        {this.state.form.membershipDetails.membershipCreditsPending || this.state.form.membershipDetails.membershipCreditsPending === 0 ? <p > { this.state.form.membershipDetails.membershipCreditsPending}</p>  : '- - -'}

                                    </Col>
                                    <Col className="py-3">
                                        <p style={{  whiteSpace: 'nowrap' }}>Used Credits </p>
                                        {this.state.form.membershipDetails.membershipcreditsused || this.state.form.membershipDetails.membershipcreditsused === 0 ? <p> { this.state.form.membershipDetails.membershipcreditsused}</p>  : '- - -'}
                                    </Col>
                                    <Col className="py-3">
                                        <p style={{ whiteSpace: 'nowrap' }} >Total Credits</p>
                                        {this.state.form.membershipDetails.membershiptotalcredits ||  this.state.form.membershipDetails.membershiptotalcredits === 0 ? <p > { this.state.form.membershipDetails.membershiptotalcredits}</p>  : '- - -'}
                                    </Col>
                                    <Col className="py-3"></Col>
                                </Row>
                                <Row className='mb-4'>
                                    <Col>
                                        <p style={{ whiteSpace: 'nowrap' }}>Auto Renewal Status</p>
                                        {this.state.form.membershipDetails.autoRenewal === 1 ? 'Enabled' : this.state.form.membershipDetails.autoRenewal === 0 ? 'Disabled' : '- - -'}

                                    </Col>
                                    
                                    {this.state.form?.membershipDetails?.autoRenewal === 0 ? <>
                                        <Col>
                                            <p style={{ whiteSpace: 'nowrap' }}> Renewal Disabled Reason</p>
                                            {this.state.form?.membershipDetails?.membershipDisableReason ? this.state.form.membershipDetails.membershipDisableReason : '- - -'}
                                            { this.state.form?.membershipDetails?.membershipDesiabledNotes  ? <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>
                                                {this.state.form?.membershipDetails?.membershipDesiabledNotes ? this.state.form.membershipDetails.membershipDesiabledNotes : '- - -'} </Tooltip>}>
                                                {this.state.form?.membershipDetails?.membershipDesiabledNotes ? <img src={`${process.env.PUBLIC_URL}/static/icons/table/notes.svg`} alt="notes" className="action-button" style={{ width: '25px' }} /> : ''}
                                            </OverlayTrigger> : ''}
                                        </Col>
                                        <Col>
                                            <p style={{ whiteSpace: 'nowrap' }}>Renewal Disabled Date</p>
                                            {this.state.form.membershipDetails.membershipModifiedDate ? this.getSignupDatetime(this.state.form.membershipDetails.membershipModifiedDate) : '- - -'}
                                        </Col>
                                        <Col>
                                            <p >Renewal Disabled By</p>
                                            {this.state.form.membershipDetails.membershipUpdatedBy ? this.updatedByNameFn(this.state.form.membershipDetails.membershipUpdatedBy) : '- - -'}
                                        </Col>
                                    </> : ''}
                                    <Col> </Col>
                                </Row>
                                <Row className='mb-4'>
                                    <Col></Col>
                                    <Col></Col>
                                    <Col><Button style={{ backgroundColor: "#A50050",border: 'none' }} disabled={!this.state.form.membershipDetails.autoRenewal} onClick={()=> this.disabledMembership()}>Disable Auto Renewal</Button>
                                    </Col>
                                    <Col>
                                    <Button style={{ backgroundColor: "#A50050",border: 'none' }} disabled={this.state.form.membershipDetails.membershipValid} onClick={()=> this.openManageCredits()}>Manage Credits</Button>
                                    </Col>
                                    <Col></Col>
                                    <Col></Col>
                                </Row>
                            </div>
                            <div className="row d-flex ml-2 my-3 justify-content-between">
                                <label style={{ fontsize: "1rem" }}> Location Buying History </label>
                                
                            </div>
                            <div className="row ml-2">
                                <Datatable config={{ ...this.config }} search={this.state.searchData ? { search: { ...this.state.filterSearch }, searchData: this.state.searchData } : null} ref={this.dataTable} onDataUpdate={this.updateTableData} />
                            </div>
                        </div>
                    </div>
                }

                <Modal centered show={this.state.reactivateLogModel} scrollable={true} onHide={() => { this.setState({ ...this.state }) }}>
                    <Modal.Header>
                        <Row xs={1} sm={1} className="w-100">
                            <Col md={5}><h5>Action</h5></Col>
                            <Col md={5}><h5>Date</h5></Col>
                        </Row>
                        <Button type="button" onClick={() => { this.setState({ reactivateLogModel: false }) }} className="close-suspension" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></Button>
                    </Modal.Header>
                    <Modal.Body>
                        {
                            this.state.reactivateLog.length > 0 ? (
                                this.state.reactivateLog.map(response => (
                                    <div className="border-bottom" key={response.createdDate + Math.random()}>
                                        <Row xs={1} sm={1} className="w-100 pt-3 pb-3">
                                            <Col md={5} style={{ wordBreak: "break-word" }}>
                                                <p>{response?.action ? response.action : '- - -'}</p>
                                            </Col>
                                            <Col md={6} style={{ wordBreak: "break-word" }}>
                                                <p>{response?.createdDate ? this.getSignupDatetime(response.createdDate) : '- - -'}</p>
                                            </Col>
                                        </Row>
                                    </div>
                                ))
                            ) : (
                                <div style={{ textAlign: "center", padding: "20px" }}>
                                    <p>No Reactivation Logs</p>
                                </div>
                            )
                        }
                    </Modal.Body>
                </Modal>


                <Modal centered show={this.state.suspendModal} className="suspendModal" scrollable={true} onHide={() => { this.setState({ ...this.state }) }}>
                    <Modal.Header>
                        <div className="w-100 d-flex justify-content-between">
                            <h5>Location</h5>
                            <div className="custom-header-checkbox" style={{ paddingRight: '8px' }}>
                                <Form>
                                    <div className={`custom-checkbox-div ${this.state.form.suspend.selectedAll ? 'checked' : ''}`} onClick={(event) => this.suspendInputChange(event, 'suspend', 'locationid', 'all')} />
                                </Form>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="border-bottom">
                            <div className="inputWithButton">
                                <Form.Control type="text" name="selectedLocation" className="my-3 ml-3" placeholder="Search by location name" value={this.state.form.suspend.selectedLocation} onChange={(event) => this.filterUnSuspendLocation(event.target.value)} />
                                {this.state.form.suspend.selectedLocation &&
                                    <Button variant="danger" onClick={() => this.filterUnSuspendLocation('')}>clear</Button>
                                }
                            </div>
                        </div>
                        {
                           this.unsuspendedlocationfunction()
                            .map(location =>
                                <div className="border-bottom">
                                    <div className="d-flex justify-content-between my-1 p-3">
                                        <b>{location['title']}</b>
                                        <div className="custom-header-checkbox">
                                            <Form>
                                                <div className={`custom-checkbox-div ${this.checkBoxChecked(location.id, 'suspend') ? 'checked' : ''}`} onClick={(event) => this.suspendInputChange(event, 'suspend', 'locationid', location['id'])}></div>
                                            </Form>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-end align-items-end">
                        <div id="toaster" className={this.state.suspendStatus.show ? "d-flex flex-row align-items-center justify-content-center toaster " : ''}>
                            {
                                this.state.suspendStatus.show ?
                                    <ToasterMessage type={this.state.suspendStatus.type} message={this.state.suspendStatus.message} className="alert-handle"></ToasterMessage>
                                    : null
                            }
                        </div>
                        <div className="d-flex">
                            <Button onClick={() => this.resetSuspend()} disabled={this.state.suspendLoading} className="btn-white"> Cancel</Button>
                            <Button onClick={() => this.submitSuspend()} disabled={!this.state.form.suspend.valid || this.state.suspendLoading} className="btn-secondary ml-2">Suspend {this.state.suspendDataLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                        </div>
                    </Modal.Footer>
                </Modal>
                <Modal centered show={this.state.form.membershipDetails.reasonModal} className="reasonModal" onHide={() => this.setState({ ...this.state })} scrollable={true}>
                    <Modal.Body>
                        <div className="form-fields" style={{ width: "95%" }}>
                            <div className="d-flex" style={{ color: '#878787' }}>
                                <Form.Label htmlFor="reason" className="required">Disable Reason</Form.Label>
                                <Form.Control as="select" name="disabledReasonType" value={this.state.form.membershipDetails?.disabledReasonType?.value} onChange={(event) => this.disabledReason(event)}>
                                    <option value="" selected>--Select--</option>
                                    {
                                        DISABLED_REASON.map((elem, index) => {
                                            return <option key={index} value={elem}>{elem}</option>
                                        })
                                    }
                                </Form.Control>
                            </div>

                            <div className="d-flex" style={{ color: '#878787' }}>
                                <Form.Label htmlFor="reason" className="required">Add Notes</Form.Label>
                                <span className="align-self-end ml-auto mb-1">{128 - (this.state.form.membershipDetails?.disabledReason?.value?.length ? this.state.form.membershipDetails?.disabledReason?.value?.length : 0)}/128</span>
                            </div>
                            <div className="float-control">

                                <Form.Control as="textarea" id="reason" name="disabledReason" value={this.state.form?.membershipDetails?.disabledReason?.value} maxLength="128" className={this.state.form.membershipDetails?.disabledReason?.value ? 'form-control-active' : ''} style={{ height: '100px' }} placeholder=" " onChange={(event) => this.disabledReason(event)} />
                                <div className="text">
                                    {
                                       this.state.form.membershipDetails?.disabledReason?.value?.error && this.state.form.membershipDetails?.disabledReason?.value?.error.length ? <small className="error">{this.state.form.membershipDetails?.disabledReason.value.error}</small> : null
                                    }
                                </div>

                            </div>

                        </div>
                        <div>
                            <div className="d-flex justify-content-center align-item-center">
                                <Button className="btn-white mx-2" onClick={() => this.resetDisableModel()}>Cancel</Button>
                                <Button variant="secondary" disabled={!this.state.form.membershipDetails?.disabledReasonType?.value || !this.state.form.membershipDetails?.disabledReason?.value} onClick={() => this.setDisabledReason()} >Confirm {this.state.membershipDisable ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal centered show={this.state.form.suspend.reasonModal} className="reasonModal" onHide={() => this.setState({ ...this.state })} scrollable={true}>
                    <Modal.Body>
                        <div className="form-fields" style={{ width: "95%" }}>
                            <div className="d-flex" style={{ marginBottom: "10px" }}>
                                <small className='text-danger'>If you feel this customer is a threat to the network, please contact <span style={{ color: '#A50050', cursor: 'pointer' }} onClick={() => navigateToHelpCenter(this.props.history)}>CTBids.com/help-center</span> to suspend sitewide</small>
                            </div>
                            <div className="d-flex" style={{ color: '#878787' }}>
                                <Form.Label htmlFor="reason" className="required">Suspension Reason</Form.Label>
                                <Form.Control as="select" name="suspension" value={this.state.form?.suspend?.suspensiontype?.value} onChange={(event) => this.suspendInputChange(event, 'suspend', 'suspensiontype')}>
                                    <option value="" selected>--Select--</option>
                                    {
                                        SUSPENSION_REASON.map((elem, index) => {
                                            return <option key={index} value={elem}>{elem}</option>
                                        })
                                    }
                                </Form.Control> 
                            </div>
                         
                            <div className="d-flex" style={{ color: '#878787' }}>
                                <Form.Label htmlFor="reason" className="required">Add Notes</Form.Label>
                                <span className="align-self-end ml-auto mb-1">{400 - this.state.form.suspend.reason.value.length}/400</span>
                            </div>
                            <div className="float-control">

                                <Form.Control as="textarea" id="reason" name="reason" value={this.state.form.suspend.reason.value} maxLength="400" className={this.state.form.suspend.reason.value ? 'form-control-active' : ''} style={{ height: '100px' }} placeholder=" " onChange={(event) => this.suspendInputChange(event, 'suspend', 'reason')} />
                                <div className="text">
                                    {
                                        this.state.form.suspend.reason.error && this.state.form.suspend.reason.error.length ? <small className="error">{this.state.form.suspend.reason.error}</small> : null
                                    }
                                </div>

                            </div>
                        </div>
                        <div>
                            <div id="toaster" className={this.state.suspendStatus.show ? "d-flex flex-row align-items-center justify-content-center toaster " : ''}>
                                {
                                    this.state.suspendStatus.show ?
                                        <ToasterMessage type={this.state.suspendStatus.type} message={this.state.suspendStatus.message} className="alert-handle"></ToasterMessage>
                                        : null
                                }
                            </div>
                            <div className="d-flex justify-content-center align-item-center">
                                <Button className="btn-white mx-2" onClick={() => this.resetSuspend()}>Cancel</Button>
                                <Button variant="secondary" onClick={() => this.setReasonModal()} disabled={!this.state.form.suspend.reason.value || this.state.suspendLoading || this.state.conformButton || !this.state.form.suspend.suspensiontype.value}>Confirm {this.state.suspendLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal centered show={this.state.unsuspendModal} className="suspendModal" scrollable={true} onHide={() => { this.setState({ ...this.state }) }}>
                    <Modal.Header>
                        <Row xs={1} sm={1} className="w-100">
                            <Col md={2}><h5>Location</h5></Col>
                            <Col md={2}><h5>Reason</h5></Col>
                            <Col md={2}><h5>Suspension Type</h5></Col>
                            <Col md={2}><h5>Effective Date</h5></Col>
                            <Col md={2}><h5>Suspended By</h5></Col>
                            <Col md={1} className="d-flex justify-content-end">
                                <div className="custom-header-checkbox" style={{ paddingRight: '5px' }}>
                                    <Form>
                                        <div className={`custom-checkbox-div ${this.state.form.unsuspend.selectedAll ? 'checked' : ''}`} onClick={(event) => this.suspendInputChange(event, 'unsuspend', 'locationid', 'all')} />
                                    </Form>
                                </div>
                            </Col>
                        </Row>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="border-bottom">
                            <div className="inputWithButton">
                                <Form.Control type="text" name="selectedLocation" className="my-3 ml-3" placeholder="Search by location name" value={this.state.form.unsuspend.selectedLocation} onChange={(event) => this.filterSuspendLocation(event.target.value)} />
                                {this.state.form.unsuspend.selectedLocation &&
                                    <Button variant="danger" onClick={() => this.filterSuspendLocation('')}>clear</Button>
                                }
                            </div>
                        </div>
                        {
                            this.state.form.filteredsuspendedLocations
                            .slice()
                            .sort((a, b) => a.locationtitle.localeCompare(b.locationtitle))
                            .map(location => (
                                <div className="border-bottom">
                                    <Row xs={1} sm={1} className="w-100 p-3">
                                        <Col md={2} style={{ wordBreak: "break-word" }}><b>{location['locationtitle']}</b></Col>
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{location['reason'] ? location['reason'] : 'Added to Sitewide Suspensions'}</Col>
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{location['suspensiontype'] ? location['suspensiontype'] : 'Location Status Update'}</Col>
                                        <Col md={2}><b>{moment.utc(location['effectivedate']).local().format('MM-DD-YYYY hh:mm A')} {momentTz.tz(momentTz.tz.guess()).zoneAbbr()}</b></Col>
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{location['suspendedby'] ? location['suspendedby'] : 'System Update'}</Col>
                                        <Col md={1} className="d-flex justify-content-end">
                                            <div className="custom-header-checkbox">
                                                <Form>
                                                    <div className={`custom-checkbox-div ${this.checkBoxChecked(location.locationid, 'unsuspend') ? 'checked' : ''}`} onClick={(event) => this.suspendInputChange(event, 'unsuspend', 'locationid', location['locationid'])}></div>
                                                </Form>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            ))
                        }
                    </Modal.Body>
                    <Modal.Footer >
                        <div id="toaster" className={this.state.suspendStatus.show ? "d-flex flex-row align-items-center justify-content-center toaster " : ''}>
                            {
                                this.state.suspendStatus.show ?
                                    <ToasterMessage type={this.state.suspendStatus.type} message={this.state.suspendStatus.message} className="alert-handle"></ToasterMessage>
                                    : null
                            }
                        </div>
                        <div className="d-flex justify-content-end align-items-end">
                            <div className="d-flex">
                                <Button onClick={() => this.resetUnSuspend()} disabled={this.state.suspendLoading} className="btn-white">Cancel</Button>
                                <Button onClick={() => this.submitUnSuspend()} disabled={!this.state.form.unsuspend.valid || this.state.suspendLoading || this.state.UnsuspendDisable} className="btn-secondary ml-2">Unsuspend {this.state.suspendLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
                <Modal centered show={this.state.form.credits.manageCreaditsModel} className="reasonModal" onHide={() => this.setState({ ...this.state })} scrollable={true}>
                    <Modal.Body>
                        <Form.Label htmlFor="reason" style={{ color: '#878787' }} className="required">Add Credits</Form.Label>
                        <div className="float-control">
                            <Form.Control size="lg" type="text" id="creditsadd" name="creditsadd"  placeholder=" " value={this.state.form.credits.creditsadd.value}
                                onChange={(data) => { this.creditsAdd(data) }}
                            />
                        </div>
                        <div className="d-flex" style={{ color: '#878787' }}>
                            <Form.Label htmlFor="reason" className="required">Add Notes</Form.Label>
                            <span className="align-self-end ml-auto mb-1">{1000 - this.state.form.credits.creditsReason.value.length}/1000</span>
                        </div>
                        <div className="float-control">
                            <Form.Control as="textarea" id="creditsReason" name="creditsReason" value={this.state.form.credits.creditsReason.value} maxLength="1000" className={this.state.form.credits.creditsReason.value ? 'form-control-active' : ''} style={{ height: '100px' }} placeholder=" " onChange={(data) => { this.creditsAdd(data) }} />
                            <div className="text">
                                {
                                    this.state.form.credits.creditsReason.error && this.state.form.credits.creditsReason.error.length ? <small className="error">{this.state.form.credits.creditsReason.error}</small> : null
                                }
                            </div>
                        </div>
                        <div>
                            <div id="toaster" className={this.state.suspendStatus.show ? "d-flex flex-row align-items-center justify-content-center toaster " : ''}>
                                {
                                    this.state.form.credits.creditError.show ?
                                        <ToasterMessage type={this.state.form.credits.creditError.type} message={this.state.form.credits.creditError.error} className="alert-handle"></ToasterMessage>
                                        : null
                                }
                            </div>
                            <div className="d-flex justify-content-center align-item-center">
                                <Button className="btn-white mx-2" onClick={() => this.closeCreditsModel()}>Cancel</Button>
                                <Button variant="secondary" onClick={() => this.setCreditsValue()} disabled={!this.state.form.credits?.creditsReason?.value || !this.state.form.credits?.creditsadd?.value}>Confirm {this.state.manageCreditsButton ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>


                <Modal show={this.state.invoiceModal}  className={`invoiceModal ${this.state.windowWidth > 780 ? 'modal-dialog-centered' : ''}`} onHide={() => { this.setState({ invoiceModal: false }) }}>
                    <Modal.Header style={{ display: "contents", marginTop: "-5%", marginRight: "1%" }}>
                        <button type="button" className="close" onClick={() => { this.setState({ invoiceModal: false }) }}>
                            <span aria-hidden="true" style={{ color: "#fff", fontSize: "2rem" }}>×</span>
                            <span class="sr-only">Close</span>
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <InvoiceView id={this.state.invoiceId} type={this.state.invoiceType} />
                    </Modal.Body>
                </Modal>

                <Modal show={this.state.membershipInvoiceModal} className={`invoiceModal ${this.state.windowWidth > 780 ? 'modal-dialog-centered' : ''}`} onHide={() => { this.setState({ invoiceModal: false }) }}>
                    <Modal.Header style={{ display: "contents", marginTop: "-5%", marginRight: "1%" }}>
                        <button type="button" className="close" onClick={() => { this.setState({ membershipInvoiceModal: false }) }}>
                            <span aria-hidden="true" style={{ color: "#fff", fontSize: "2rem" }}>×</span>
                            <span class="sr-only">Close</span>
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <MembershipInvoice buyerid={this.buyerId} />
                    </Modal.Body>
                </Modal>
                {/* modal to change email */}
                <Modal centered show={this.state.emailModal} className="change-email-modal" size="md" animation={false} keyboard={false}>
                    <Modal.Body>
                      <div className="d-flex flex-column justify-content-center align-items-center w-100">
                            <div className="float-control" style={{ width: "90%" }}>
                                <div className="text" style={{lineHeight: '12px', top: '52px', textAlign: 'left'}}>
                                    {
                                        this.state.newEmail.error ? <small className="error">{this.state.newEmail.error}</small> : null
                                    }
                                </div>
                                <Form.Control autoFocus type="text" id="new-email" name="newEmail" placeholder=" "
                                    disabled={(this.state.emailVerifyLoading || this.state.form.unverifiedemail === this.state.newEmail.value) && !this.state.form.isemailchanged} value={this.state.newEmail.value} onChange={this.onEmailChange} />
                                <label htmlFor="newEmail" className="required">New Email</label>
                            </div>
                           {(this.state.form.showApple || this.state.form.showFacebookd || this.state.form.showGoogle) && <div class="alert alert-primary d-flex align-items-center"  style={{color: "#084298", backgroundColor: '#cfe2ff', borderColor: '#b6d4fe', fontSize: '0.7rem', width: '90%', marginTop: '2rem'}} role="alert">
                                <div> <i className="fa fa-info-circle" style={{ width: '10px', color: '#A50050', marginRight: '5px' }}></i>
                                All Social media accounts linked to this account will be removed after email verification is completed.
                                </div>
                            </div>}
                            <div id="toaster" className={this.state.emailStatus.show ? "d-flex flex-row align-items-center justify-content-center toaster " : ''}>
                                {
                                    this.state.emailStatus.show ?
                                        <ToasterMessage type={this.state.emailStatus.type} message={this.state.emailStatus.message} className="alert-handle"></ToasterMessage>
                                        : null
                                }
                            </div>
                            <div className="d-flex flex-column flex-sm-row mt-5">
                                <Button variant="outline-dark btn-white mx-2" onClick={this.hideEmailModal}
                                    disabled={this.state.emailVerifyLoading}>Cancel</Button>
                                <div className="d-flex flex-row justify-content-center align-items-center mt-sm-0">
                                    <Button variant="secondary mx-2" onClick={this.saveNewEmail}
                                        disabled={this.state.newEmail.error || this.state.emailVerifyLoading || this.state.profileBtnDisable  || this.state.apiLoading}>{this.state.form.unverifiedemail && !this.state.form.isemailchanged ? 'Edit' : 'Submit'}
                                        {
                                            this.state.emailVerifyLoading || this.state.apiLoading ?
                                                <Spinner style={{marginLeft: '5px'}} as="span" animation="border" size="sm" role="status" aria-hidden="true" /> :
                                                null
                                        }
                                        </Button>
                                </div>
                                {
                                    this.state.form.unverifiedemail && !this.state.form.isemailchanged ?
                                        <div className="d-flex flex-row justify-content-center align-items-center mt-2 mt-sm-0">

                                            <Button variant="secondary mx-2"
                                                disabled={this.state.emailResendLoading} onClick={this.verifyNewEmail}>Resend Verification Link</Button>
                                        </div> : null
                                }
                            </div>
                        </div> 
                    </Modal.Body>
                </Modal>
                <Modal centered show={this.state.resetModal} size="md" animation={false} onHide={() => { this.setState({ resetModal: false }) }} keyboard={false}>
                    <Modal.Body>
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            Would you like to reset the  password for this User

                               {this.state.emailValid && <small className='text-danger text-center mt-3'>A previous request to update email or password is still in progress. Submitting a new request will override the pending one.</small>}
                            <div className="d-flex flex-row mt-3">
                                <Button variant="outline-dark btn-white mx-2" style={{ width: '80px' }} onClick={() => { this.setState({ resetModal: false }) }}>Cancel</Button>
                                <Button variant="secondary mx-2" style={{ width: '80px' }} onClick={() => this.resetPassword()}>Confirm</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal centered show={this.state.signOutModal} size="md" animation={false} onHide={() => { this.setState({ signOutModal: false }) }} keyboard={false}>
                    <Modal.Body>
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            Would you like to sign this user out of all devices?

                            <div className="mt-3 p-2 text-center w-100" role="alert" style={{ fontSize: '12px', backgroundColor: '#edeef0' }}>
                                <strong>Note:</strong> This action will sign the user out of every device they’re currently using. Confirm to proceed.
                            </div>
                            <p className={`mb-3 mt-3 text-bold ${this.state.textSuccess ? 'text-success' : 'text-danger'}`}>{this.state.signoutMessage}</p>
                            <div className="d-flex flex-row">
                                <Button variant="outline-dark btn-white mx-2" onClick={() => this.setState({ signOutModal: false })}>Cancel</Button>
                                <Button disabled={this.state.signoutDisabled} variant="secondary mx-2" onClick={() => { this.logoutUser(); }}>Confirm {this.state.signOutLoading && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />}</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal centered show={this.state.deleteModal} size="md" animation={false} onHide={() => { this.setState({ deleteModal: true }) }} keyboard={false}>
                    {this.state.deleteMessage ? <Modal.Header className='align-items-end justify-content-end'>
                        {this.state.deleteMessage ?
                            <div className="close-icon" onClick={() => { this.redirectDeleteModal(); }}></div> : ''}
                    </Modal.Header> : ''}
                    <Modal.Body>
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            {!this.state.deleteMessage ? `Would you like to delete this User ?` : ''}
                           <div id="toaster" className={this.state.deleteStatus.show ? " d-flex flex-row align-items-center justify-content-center toaster" : ''} style={{ paddingTop: "3%" }} >
                                {
                                    this.state.deleteStatus.show ?
                                        <ToasterMessage type={this.state.deleteStatus.type} message={this.state.deleteStatus.message} className="alert-handle text-center"></ToasterMessage>
                                        : null
                                }
                            </div>
                            <div className="d-flex flex-row mt-4">
                                {!this.state.deleteMessage ?
                                    <><Button variant="outline-dark btn-white mx-2" style={{ width: '120px' }} onClick={() => { this.redirectDeleteModal(); }}>Cancel</Button>
                                        <Button variant="secondary mx-2" style={{ width: '120px' }} disabled={this.state.deleteStatus.type === 'success'} onClick={() => this.deleteUser()}>Confirm {this.state.deleteLoading ?
                                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}
                                        </Button></> : ''
                                }
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>


                <Modal centered show={this.state.showReactivateUserModel} size="md" animation={false} onHide={() => { this.setState({ showReactivateUserModel: true }) }} keyboard={false}>
                    <Modal.Header className="d-flex justify-content-center align-items-center" style={{ position: "relative", color: '#A50050' }}>
                        <div className='text-bold'>
                            ADMIN Customer Account Reactivation
                        </div>

                        {/* Question Mark Icon */}
                        <span
                            onMouseEnter={this.handleMouseEnter}
                            onMouseLeave={this.handleMouseLeave}
                            style={{ position: "relative", display: "inline-block", marginLeft: "5px", cursor: "pointer" }}
                        >
                            <i className="fa fa-question-circle" style={{ fontSize: "14px" }}></i>

                            {/* Tooltip */}
                            {this.state.showTooltip && (
                              <div className="info-box">
                              
                              <b className='info-bold-text'>If the customer has the same phone number and needs to update their email address:</b>
                              <p className='info-text'>• Please use the ‘Click here to change/update email address’ option.</p>
                              <p className='info-text'>• Once the email is entered, the customer will receive an OTP to their current phone number. Please enter the OTP provided to you by the customer. Once verified, the customer will receive an email to their new email address for verification and set a new password.</p>
                            
                              <b className='info-bold-text'>If the customer has a different phone number but still has the same email address:</b>
                              <p className='info-text'>• Please use the ‘Click here to change phone number’ option.</p>
                              <p className='info-text'>• Once the new phone number is entered, an OTP will be sent to the newly updated phone number.</p>
                              <p className='info-text'>• Please enter the OTP provided to you by the customer. Once verified, the customer will receive an email to their current email address for verification and set a new password.</p>
                            
                              <b className='info-bold-text'>If the customer has the same phone number and same email address:</b>
                              <p className='info-text'>• Please click the ‘Save’ option as both the email and phone number are already listed correctly in the fields. The customer will receive an OTP to their current phone number.</p>
                              <p className='info-text'>• Please enter the OTP provided to you by the customer. Once verified, the customer will receive an email to the current email address for verification and set a new password.</p>
                            
                              <b className='info-bold-text'>If the customer has a new phone number and new email address:</b>
                              <p className='info-text'>• We are unable to verify current account information to validate the customer. The customer will need to create a new account with their new information.</p>
                            </div>
                            
                            )}
                        </span>
                    </Modal.Header>

                    <Modal.Body>

                            <div className="d-flex flex-column justify-content-center align-items-center">

                                <div className="mt-2 w-100">
                                    <Button className="btn-email"
                                        disabled={this.state.allowEmail || this.state.otpAllow } onClick={() => { this.setState({ allowPhoneNumber: false, }) }}>Click here to change Phone Number</Button>
                                    <div className="float-control" style={{ margin: "-2% 0%" }}>
                                        <div className="">
                                            {
                                                this.state.reactive.mobile.error ? <small className="text-danger" style={{lineHeight: '15px'}}>{this.state.reactive.mobile.error}</small> : null
                                            }
                                        </div>
                                        <Form.Control style={{ backgroundColor: this.state.allowPhoneNumber ? '#cbcbcb' : '' }} size="lg" type="text" id="mobile" name="mobile" disabled={this.state.allowPhoneNumber || this.state.otpAllow } value={this.state.reactive.mobile.value} onChange={(event) => this.phoneEmailValueCheck(event)} placeholder=" " />
                                        <Form.Label htmlFor="mobile" className="required">Phone Number</Form.Label>
                                    </div>
                                </div>

                                <div className='w-100 mt-3 mb-3'>
                                    <Button className="btn-email"
                                        disabled={!this.state.allowPhoneNumber || this.state.otpAllow || this.state.reactive.mobile.value == ""} onClick={() => { this.setState({ allowEmail: true }) }}>Click here to change/update email address</Button>
                                    <div className="float-control w-100" style={{ margin: "-2% 0%" }}>
                                        <div className="">
                                            {
                                                this.state.reactive.email.error ? <small  className="text-danger"style={{lineHeight: '15px'}}>{this.state.reactive.email.error}</small> : null
                                            }
                                        </div>
                                        <Form.Control size="lg" type="text" id="" name="email" disabled={!this.state.allowEmail || this.state.otpAllow } value={this.state.reactive.email.value} onChange={(event) => this.phoneEmailValueCheck(event)} placeholder=" " />
                                        <Form.Label htmlFor="email" className="required">Email</Form.Label>
                                    </div>
                                </div>
                            </div>
                        


                      

                        {this.state.otpAllow ? <div className="float-control lg  w-100">
                            <Form.Control size="lg" type="text" id="phoneNumberOtp" maxLength="6" name="phoneNumberOtp" placeholder=" " value={this.state.reactive.phoneNumberOtp.value} onChange={(event) => this.otpCheck(event)} />
                            <Form.Label htmlFor="phoneNumberOtp" className="required">Phone Number OTP</Form.Label>
                        </div> : ''}


                        {!this.state.allowEmail &&
                            <div className="text-center  text-danger">
                                {this.state.verifyPhonenumber && (this.state?.reactive?.mobile?.value?.replace(/\D/g, '') == this.state.form.mobile) ? `Customer's phone number and email has not changed` : `Customer's phone number has changed but the current account email has not changed`}
                            </div>
                        }

                        <div className="text text-center  text-danger">
                            {this.state.emailVerify && (this.state.reactive.email.value !== this.state.form.email) ? `Customer's email has changed but the current phone number has not changed` : ''}
                        </div> 


                        {this.state.reactivateMsg && <div className={`${this.state.messagetype ? 'text-success' : 'text-danger'} text-center`}>
                            {this.state.reactivateMsg}
                        </div>}

                        <div className="d-flex justify-content-center align-items-center mt-4">

                            <Button variant="outline-dark btn-white mx-2" style={{ width: '120px' }} onClick={() => this.handleCancel()} >Cancel</Button>
                            <>
                                {!this.state.otpAllow ? <>

                                    <Button variant="secondary mx-2" name="text" style={{ width: '120px' }} disabled={this.state.reactive.formvalid || this.state.reactive.mobile.value === "" || this.state.profileBtnDisable || this.state.apiLoading} onClick={() => this.phoneNumberOtpfn('sms')}>Save
                                    {this.state.apiLoading ? <Spinner style={{marginLeft: '5px'}} as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                                </> :
                                    <>
                                        <Button variant="secondary mx-2" style={{ width: '120px' }} disabled={this.state.reactive.phoneNumberOtp.value == "" || this.state.disablePhonenumberBtn } onClick={() => this.phoneNumberVerify()} >Verify
                                        </Button>

                                    </>
                                }
                            </>
                        </div>
                        {this.state.otpAllow ? <div className='d-flex justify-content-center align-items-center mt-3'>
                            Not received? <span className='' style={{ marginLeft: '3px', color: '#007bc2', cursor: 'pointer' }} onClick={() => this.resendOtp()} > Resend
                                {
                                    this.state.resendOtpload ?
                                        <Spinner className="ml-1" animation="border" as="span" size="sm" /> :
                                        null
                                }
                            </span>
                        </div> : ''}
                    </Modal.Body>
                </Modal>

                { /* modal to update profile address */ }
                <Modal id="profile-address-modal" centered show={this.state.profileAddressModal} size="md" animation={false}  keyboard={false}>
                    <Modal.Header className='header text-secondary'>Edit Profile</Modal.Header>
                    <Modal.Body>
                        <Form className="profile-modal">
                            <div className="row-handle d-lg-flex">
                                <div className="col-handle-2">
                                    <div className="float-control lg">
                                        <Form.Control size="lg" type="text" id="firstname" name="profile_firstname" placeholder=" " value={this.state.profileUpdateForm.profile_firstname.value} onChange={(e)=>{this.onInputValidation(e, "profile_firstname")}} />
                                        <Form.Label htmlFor="firstname" className="required">First Name</Form.Label>
                                    </div>
                                </div>
                                <div className="col-handle-2">
                                    <div className="float-control lg"> 
                                        <Form.Control size="lg" type="text" id="lastname" name="profile_lastname" placeholder=" " value={this.state.profileUpdateForm.profile_lastname.value} onChange={(e)=>{this.onInputValidation(e, "profile_lastname")}} />
                                        <Form.Label htmlFor="lastname" className="required">Last Name</Form.Label>
                                    </div>
                                </div>
                            </div>
                            <div className='d-flex align-items-center justify-content-center text-center mb-10'>
                                {
                                    this.state.profileUpdateForm.profile_firstname.error ? <small className="text-danger">{this.state.profileUpdateForm.profile_firstname.error}</small> : this.state.profileUpdateForm.profile_lastname.error ?  <small className="text-danger">{this.state.profileUpdateForm.profile_lastname.error}</small>  : null
                                }
                            </div>
                            <div id="toaster" className={this.state.resetStatus.show && this.state.profileUpdateStatus.show ? " d-flex flex-row align-items-center justify-content-center toaster" : ''} >
                                {
                                    this.state.resetStatus.show ?
                                        <ToasterMessage type={this.state.resetStatus.type} message={this.state.resetStatus.message} className="d-flex text-center align-items-center justify-content-center"></ToasterMessage>
                                        : this.state.profileUpdateStatus.show ?
                                        <ToasterMessage type={this.state.profileUpdateStatus.type} message={this.state.profileUpdateStatus.message} className="d-flex text-center align-items-center justify-content-center"></ToasterMessage>
                                        : null
                                }
                            </div>
                            <div className="buttons d-flex" style={{justifyContent: "center"}}>
                                <Button variant="outline-primary w-20" onClick={this.cancelProfileAddress}>Cancel</Button>
                                <Button variant="secondary w-20 ml-10" onClick={this.updateProfileAddress} disabled={!this.state.profileUpdateFormValid ||this.state.profileUpdateStatus.message || this.state.updateNameLoader || this.state.isSaveDisable || this.state.profile_firstname || this.state.profile_lastname ||  this.state.profileUpdateForm.profile_firstname.error  || this.state.profileUpdateForm.profile_lastname.error  || this.state.profileBtnDisable || this.state.apiLoading }>Save
                                {this.state.apiLoading || this.state.updateNameLoader ? <Spinner style={{marginLeft: '5px'}} as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal>
                { this.state.form.buyerSuspendCount ? <Modal centered show={this.state.showSuspendedModal} className="suspendModal" scrollable={true} onHide={() => { this.setState({ ...this.state }) }}>
                    <Modal.Header>
                        <Row xs={1} sm={1} className="w-100">
                            <Col md={3}><h5>Location</h5></Col>
                            <Col md={2}><h5>Reason</h5></Col>
                            <Col md={2}><h5>Suspension Type</h5></Col>
                            <Col md={2}><h5>Suspension Date</h5></Col>
                            <Col md={2}><h5>Suspended By</h5></Col>
                        </Row>
                        <Button type="button" onClick={() => {this.setState({ showSuspendedModal: false })}} className="close-suspension" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></Button> 
                    </Modal.Header>
                    <Modal.Body>
                        {
                            this.state.suspendList
                            .slice()
                            .sort((a, b) => a.locationtitle.localeCompare(b.locationtitle)).map(response =>
                                <div className="border-bottom">
                                    <Row xs={1} sm={1} className="w-100 p-3">
                                        <Col md={3} style={{ wordBreak: "break-word" }}><b>{response['locationtitle'] ? response['locationtitle'] : '- - -' }</b></Col>
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{response['reason'] ? response['reason'] : 'Added to Sitewide Suspensions' }</Col>
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{response['suspensiontype'] ? response['suspensiontype']  : 'Location Status Update' }</Col>
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{moment.utc(response['effectivedate']).local().format('MM-DD-YYYY hh:mm A')} {momentTz.tz(momentTz.tz.guess()).zoneAbbr()}</Col>
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{response['suspendedby'] ? response['suspendedby'] : 'System Update'}</Col>
                                    </Row>
                                </div>
                            )
                        }
                    </Modal.Body>
                </Modal> : ''}

                <Modal centered show={this.state.form.unsuspendReason.unsuspendReasonModal} className="reasonModal" onHide={() => this.setState({ ...this.state })} scrollable={true}>
                    <Modal.Body>
                        <div className="form-fields" style={{ width: "95%" }}>
                            <div className="d-flex" style={{ marginBottom: "10px" }}>
                                <small className='text-danger'>If you need the suspension lifted for the entire network, please contact <span style={{ color: '#A50050', cursor: 'pointer' }} onClick={() => navigateToHelpCenter(this.props.history)}>CTBids.com/help-center</span> </small>
                            </div>
                            <div className="d-flex" style={{ color: '#878787' }}>
                                <Form.Label htmlFor="revokereason" className="required">UnSuspension Reason</Form.Label>
                                <Form.Control as="select" name="suspension" value={this.state.form.unsuspendReason.revoketype.value} onChange={(event) => this.suspendInputChange(event, 'unsuspendReason', 'revoketype')}>
                                    <option value="" selected>--Select--</option>
                                    {
                                        UNSUSPENSION_REASON.map((elem, index) => {
                                            return <option key={index} value={elem}>{elem}</option>
                                        })
                                    }
                                </Form.Control> 
                            </div>
                            <div className="d-flex" style={{ color: '#878787' }}>
                                <Form.Label htmlFor="revokereason" className="required">Add Notes</Form.Label>
                                <span className="align-self-end ml-auto mb-1">{400 - this.state.form.unsuspendReason.revokereason.value.length}/400</span>
                            </div>
                            <div className="float-control">

                                <Form.Control as="textarea" id="revokereason" name="revokereason" value={this.state.form.unsuspendReason.revokereason.value} maxLength="400" className={this.state.form.unsuspendReason.revokereason.value ? 'form-control-active' : ''} style={{ height: '100px' }} placeholder=" " onChange={(event) => this.suspendInputChange(event, 'unsuspendReason', 'revokereason')} />
                                <div className="text">
                                    {
                                        this.state.form.unsuspendReason.revokereason.error && this.state.form.unsuspendReason.revokereason.error.length ? <small className="error">{this.state.form.unsuspendReason.revokereason.error}</small> : null
                                    }
                                </div>

                            </div>
                        </div>
                        <div>
                            <div id="toaster" className={this.state.suspendStatus.show ? "d-flex flex-row align-items-center justify-content-center toaster " : ''}>
                                {
                                    this.state.suspendStatus.show ?
                                        <ToasterMessage type={this.state.suspendStatus.type} message={this.state.suspendStatus.message} className="alert-handle"></ToasterMessage>
                                        : null
                                }
                            </div>
                            <div className="d-flex justify-content-center align-item-center">
                                <Button className="btn-white mx-2" onClick={() => this.resetUnSuspend()}>Cancel</Button>
                                <Button variant="secondary" onClick={() => this.setUnSuspendReasonModal()} disabled={!this.state.form.unsuspendReason.revokereason.value || !this.state.form.unsuspendReason.revoketype.value}>Confirm {this.state.suspendLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                { this.state.form?.unsuspendedcount > 0 ? <Modal centered show={this.state.unsuspensionModal} className="suspendModal" scrollable={true} onHide={() => { this.setState({ ...this.state }) }}>
                    <Modal.Header>
                        <Row xs={1} sm={1} className="w-100">
                            <Col md={3}><h5>Location</h5></Col>
                            <Col md={2}><h5>Reason</h5></Col>
                            <Col md={2}><h5>UnSuspension Type</h5></Col>
                            <Col md={2}><h5>UnSuspension Date</h5></Col>
                            <Col md={2}><h5>UnSuspended By</h5></Col>
                        </Row>
                        <Button type="button" onClick={() => {this.setState({ unsuspensionModal: false })}} className="close-suspension" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></Button> 
                    </Modal.Header>
                    <Modal.Body>
                        {
                            this.state.unsuspendList.map(response =>
                                <div className="border-bottom">
                                    <Row xs={1} sm={1} className="w-100 p-3">
                                        <Col md={3} style={{ wordBreak: "break-word" }}><b>{response['locationtitle'] ? response['locationtitle']  : '- - -'}</b></Col>
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{response['revokereason'] ? response['revokereason']  : '- - -' }</Col>
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{response['revoketype']? response['revoketype'] :  '- - -'}</Col>
                                        {response['revokedate'] ? 
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{moment.utc(response['revokedate']).local().format('MM-DD-YYYY hh:mm A')} {momentTz.tz(momentTz.tz.guess()).zoneAbbr()}</Col> : <Col md={2} style={{ wordBreak: "break-word" }}>{'- - -'}</Col>}
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{response['revokedby'] ? response['revokedby'] : '- - -'}</Col>
                                    </Row>
                                </div>
                            )
                        }
                    </Modal.Body>
                </Modal> : ''}

            </div>
        );
    }
}